// // import React, { useState } from 'react';
// // import { useNavigate, useLocation } from 'react-router-dom';
// // import {
// //   Box,
// //   Typography,
// //   TextField,
// //   Button,
// //   Select,
// //   MenuItem,
// //   FormControl,
// //   InputLabel,
// //   Grid,
// //   Card,
// //   CardContent,
// //   Container,
// //   useTheme,
// //   useMediaQuery,
// //   InputAdornment
// // } from '@mui/material';

// // // Import icons (you'll need to add these to your assets)
// // import yourIcon from '../assets/greencir.png';
// // import uploadImageIcon from '../assets/appimage.png';
// // import uploadVideoIcon from '../assets/appvideo.png';
// // import youtubeIcon from '../assets/appyoutu.png';
// // import downArrowIcon from '../assets/downarro.png';

// // // Property type icons
// // import selfServiceIcon from '../assets/ware comm.png';
// // import commercialIcon from '../assets/plotcomm.png';
// // import residentialIcon from '../assets/showcomm.png';
// // import specialPurposeIcon from '../assets/retailcomm.png';
// // import openSpaceIcon from '../assets/otherscomm.png';
// // import agriculturalLandIcon from '../assets/officecomm.png';
// // import othersIcon from '../assets/officecomm.png';

// // const PropertyCommercial = () => {
// //   const theme = useTheme();
// //   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
// //   const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  
// //   const navigate = useNavigate();  
// //   const location = useLocation();
// //   const { propertyType, category } = location.state || {    
// //     propertyType: 'Commercial',    
// //     category: 'Sell'  
// //   };


// // const [propertyImages, setPropertyImages] = useState([]);
// // const [propertyVideos, setPropertyVideos] = useState([]);

// // // Add these handler functions
// // const handleImageUpload = (event) => {
// //   const files = event.target.files;
// //   if (files.length > 10) {
// //     alert("You can only upload up to 10 images");
// //     return;
// //   }
// //   setPropertyImages(Array.from(files));
// // };

// // const handleVideoUpload = (event) => {
// //   const files = event.target.files;
// //   if (files.length > 3) {
// //     alert("You can only upload up to 3 videos");
// //     return;
// //   }
// //   setPropertyVideos(Array.from(files));
// // };



// //   // State for form selections
// //   const [selectedPropertyType, setSelectedPropertyType] = useState('self-service');
// //   const [selectedUse, setSelectedUse] = useState('');
// //   const [selectedPropertyStatus, setSelectedPropertyStatus] = useState('');
// //   const [buildingName, setBuildingName] = useState('');
// //   const [areaName, setAreaName] = useState('');
// //   const [propertySize, setPropertySize] = useState('');
// //   const [selectedUnit, setSelectedUnit] = useState('Sq. ft.');
// //   const [description, setDescription] = useState('');
// //   const [totalFloors, setTotalFloors] = useState('');
// //   const [selectedFloor, setSelectedFloor] = useState('Mezzine');


// //   const [selectedOwnership, setSelectedOwnership] = useState('Freehold');


// //   // Property type options data
// //   const propertyTypes = [
// //     { id: 'industrial', name: 'Industrial' },
// //     { id: 'commercial', name: 'Commercial' },
// //     { id: 'residential', name: 'Residential' },
// //     { id: 'sez', name: 'Special economic zone' },
// //     { id: 'openspaces', name: 'Open spaces' },
// //     { id: 'agriculture', name: 'Agriculture zone' },
// //     { id: 'others', name: 'Others' },
// //   ];

// //   // Use options
// //   const useOptions = [
// //     { id: "it-park", label: "IT Park" },
// //     { id: "business-park", label: "Business Park" },
// //     { id: "others", label: "Others" },
// //   ];

// //   // Property status options
// //   const propertyStatusOptions = [
// //     { id: "ready-occupancy", label: "Ready Occupancy" },
// //     { id: "under-construction", label: "Under Construction" },
// //     { id: "resale", label: "Resale" },
// //   ];

// //   const handleBack = () => {
// //     navigate('/add-new-property');
// //   };

  

// // // Update the handleNext function
// // const handleNext = () => {
// //   // Validate required fields
// //   if (!buildingName || !areaName || !propertySize || !selectedUnit || 
// //       !selectedPropertyType || !selectedUse || !selectedPropertyStatus) {
// //     alert("Please fill all required fields");
// //     return;
// //   }

// //   // Collect all property details
// //   const propertyDetails = {
// //     propertyType: 'Commercial',
// //     category,
// //     location: location.state?.location || '',
// //     asset_type: selectedPropertyType,
// //     buildingName,
// //     areaName,
// //     propertySize,
// //     property_size_units: selectedUnit,
// //     length: '',
// //     width: '',
// //     totalFloors,
// //     selectedFloor,
    
// //     // Commercial-specific fields
// //     commercial_catgory: category === 'Sell' ? 'sale' : 'rent',
// //     commercial_asset_type: selectedPropertyType,
// //     hub: selectedUse,
// //     ownership: selectedOwnership,
    
// //     // Status
// //     construction_status: selectedPropertyStatus === 'ready-occupancy' ? 'ready to move' : 'under construction',
    
// //     // Images and videos
// //     propertyImages,
// //     propertyVideos,
    
// //     // Default amenities for commercial properties
// //     society_aminities: 'Lift, Parking, Gym',
// //     furnish_facilities: 'Modular Kitchen, Sofa',
// //     other_facilities: 'Power Backup, Security',
// //     facilities_distance: '1km'
// //   };
  
// //   if (category === 'Rent') {
// //     navigate('/rent-details', {
// //       state: propertyDetails
// //     });
// //   } else {
// //     navigate('/price-details', {
// //       state: propertyDetails
// //     });
// //   }
// // };

// //   const handlePropertyTypeSelect = (typeId) => {
// //     setSelectedPropertyType(typeId);
// //   };

// //   const handleUseSelect = (useId) => {
// //     setSelectedUse(useId);
// //   };

// //   const handlePropertyStatusSelect = (statusId) => {
// //     setSelectedPropertyStatus(statusId);
// //   };

// //   return (
// //     <Box sx={{ backgroundColor: '#f5f5f5', minHeight: '100vh', py: isMobile ? 1 : 2 }}>
// //       <Container maxWidth="lg" sx={{ px: isMobile ? 1 : 2 }}>
// //         <Box sx={{ 
// //           maxWidth: '1100px',
// //           mx: 'auto',
// //           mt: isMobile ? 2 : 4,
// //           mb: isMobile ? 2 : 4,
// //           backgroundColor: 'white', 
// //           borderRadius: isMobile ? '12px' : '20px', 
// //           border: '1px solid #d0d0d0', 
// //           p: isMobile ? 2 : 5,
// //           boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
// //         }}>
// //           {/* Progress Steps */}
// //           <Box sx={{ 
// //             display: 'flex', 
// //             justifyContent: 'center', 
// //             alignItems: 'center', 
// //             mb: isMobile ? 3 : 4,
// //             px: isMobile ? 1 : 0
// //           }}>
// //             <Box sx={{ 
// //               display: 'flex', 
// //               alignItems: 'center',
// //               flexDirection: isMobile ? 'column' : 'row',
// //               gap: isMobile ? 2 : 0
// //             }}>
// //               {/* Step 1 - Completed */}
// //               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
// //                 <Typography sx={{
// //                   mb: 1,
// //                   fontSize: isMobile ? '14px' : '16px',
// //                   fontWeight: 'normal',
// //                   color: 'black',
// //                   fontFamily: 'Outfit',
// //                   textAlign: 'center'
// //                 }}>
// //                   Basic Details
// //                 </Typography>
// //                 <Box sx={{
// //                   width: isMobile ? 30 : 35,
// //                   height: isMobile ? 30 : 35,
// //                   borderRadius: '50%',
// //                   border: '3px solid #1a507d',
// //                   backgroundColor: 'white',
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center'
// //                 }}>
// //                   <Box
// //                     component="img"
// //                     src={yourIcon}
// //                     alt="Step Icon"
// //                     sx={{
// //                       width: isMobile ? 18 : 22,
// //                       height: isMobile ? 18 : 22,
// //                       objectFit: 'contain'
// //                     }}
// //                   />
// //                 </Box>
// //               </Box>
              
// //               {/* Divider */}
// //               <Box sx={{ 
// //                 width: isMobile ? '1px' : '100px', 
// //                 height: isMobile ? '20px' : '1px', 
// //                 backgroundColor: '#d0d0d0', 
// //                 mx: isMobile ? 0 : 2,
// //                 my: isMobile ? 1 : 0
// //               }} />
              
// //               {/* Step 2 - Active */}
// //               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
// //                 <Typography sx={{
// //                   mb: 1,
// //                   fontSize: isMobile ? '14px' : '16px',
// //                   fontWeight: 'normal',
// //                   color: 'black',
// //                   fontFamily: 'Outfit',
// //                   textAlign: 'center'
// //                 }}>
// //                   Property Details
// //                 </Typography>
// //                 <Box sx={{
// //                   width: isMobile ? 30 : 35,
// //                   height: isMobile ? 30 : 35,
// //                   borderRadius: '50%',
// //                   border: '3px solid #1a507d',
// //                   backgroundColor: 'white',
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center'
// //                 }}>
// //                   <Box sx={{
// //                     width: isMobile ? 18 : 22,
// //                     height: isMobile ? 18 : 22,
// //                     backgroundColor: '#1c274c',
// //                     borderRadius: '50%'
// //                   }} />
// //                 </Box>
// //               </Box>

// //               {/* Divider */}
// //               <Box sx={{ 
// //                 width: isMobile ? '1px' : '100px', 
// //                 height: isMobile ? '20px' : '1px', 
// //                 backgroundColor: '#d0d0d0', 
// //                 mx: isMobile ? 0 : 2,
// //                 my: isMobile ? 1 : 0
// //               }} />

// //               {/* Step 3 - Inactive */}
// //               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
// //                 <Typography sx={{
// //                   mb: 1,
// //                   fontSize: isMobile ? '14px' : '16px',
// //                   fontWeight: 'normal',
// //                   color: 'black',
// //                   fontFamily: 'Outfit',
// //                   textAlign: 'center'
// //                 }}>
// //                   Price Details
// //                 </Typography>
// //                 <Box sx={{
// //                   width: isMobile ? 30 : 35,
// //                   height: isMobile ? 30 : 35,
// //                   borderRadius: '50%',
// //                   backgroundColor: '#ebf6ff'
// //                 }} />
// //               </Box>           
// //             </Box>
// //           </Box>
          
// //           {/* Main Title */}
// //           <Typography sx={{
// //             fontSize: isMobile ? '18px' : '22px',
// //             fontWeight: 500,
// //             color: 'black',
// //             fontFamily: 'Outfit',
// //             mb: isMobile ? 2 : 3,
// //             textAlign: isMobile ? 'center' : 'left'
// //           }}>
// //             Add Property Details
// //           </Typography>

// //           {/* Images & Videos Section */}
// //           <Box sx={{ mb: isMobile ? 2 : 3 }}>
// //             <Typography sx={{
// //               fontSize: isMobile ? '14px' : '16px',
// //               fontWeight: 500,
// //               color: '#666',
// //               fontFamily: 'Outfit',
// //               mb: 1
// //             }}>
// //               Images & Videos
// //             </Typography>
// //            <Box
// //   sx={{
// //     height: isMobile ? 120 : 140,
// //     border: '1px solid #d0d0d0',
// //     borderRadius: '8px',
// //     display: 'flex',
// //     flexDirection: 'column',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     mb: 2,
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// //     '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#4f26ff' },
// //     '&:active': { backgroundColor: '#f0f0f0' },
// //     position: 'relative'
// //   }}
// //   onClick={() => document.getElementById('property-images').click()}
// // >
// //   <input
// //     type="file"
// //     id="property-images"
// //     multiple
// //     accept="image/*"
// //     style={{ display: 'none' }}
// //     onChange={handleImageUpload}
// //   />
// //   <Box
// //     component="img"
// //     src={uploadImageIcon}
// //     alt="Upload Images"
// //     sx={{ 
// //       width: isMobile ? 50 : 60, 
// //       height: isMobile ? 50 : 60, 
// //       mb: 1 
// //     }}
// //   />
// //   <Typography
// //     sx={{
// //       fontSize: isMobile ? '14px' : '16px',
// //       fontWeight: 500,
// //       color: '#666',
// //       fontFamily: 'Outfit',
// //       textAlign: 'center',
// //       px: 1
// //     }}
// //   >
// //     {isMobile ? 'Upload Images (Max 10)' : '(Upload Images - Max 10 Images)'}
// //   </Typography>
// //   {propertyImages.length > 0 && (
// //     <Typography
// //       sx={{
// //         fontSize: isMobile ? '12px' : '14px',
// //         fontWeight: 500,
// //         color: '#4f26ff',
// //         fontFamily: 'Outfit',
// //         textAlign: 'center',
// //         mt: 0.5
// //       }}
// //     >
// //       {propertyImages.length} {propertyImages.length === 1 ? 'image' : 'images'} selected
// //     </Typography>
// //   )}
// //            </Box>
// //             {/* Upload Videos */}
// //              <Box
// //   sx={{
// //     height: isMobile ? 120 : 140,
// //     border: '1px solid #d0d0d0',
// //     borderRadius: '8px',
// //     display: 'flex',
// //     flexDirection: 'column',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     cursor: 'pointer',
// //     transition: 'all 0.2s ease',
// //     '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#4f26ff' },
// //     '&:active': { backgroundColor: '#f0f0f0' },
// //     position: 'relative'
// //   }}
// //   onClick={() => document.getElementById('property-videos').click()}
// // >
// //   <input
// //     type="file"
// //     id="property-videos"
// //     multiple
// //     accept="video/*"
// //     style={{ display: 'none' }}
// //     onChange={handleVideoUpload}
// //   />
// //   <Box
// //     component="img"
// //     src={uploadVideoIcon}
// //     alt="Upload Videos"
// //     sx={{ 
// //       width: isMobile ? 50 : 60, 
// //       height: isMobile ? 50 : 60, 
// //       mb: 1 
// //     }}
// //   />
// //   <Typography
// //     sx={{
// //       fontSize: isMobile ? '14px' : '16px',
// //       fontWeight: 500,
// //       color: '#666',
// //       fontFamily: 'Outfit',
// //       textAlign: 'center',
// //       px: 1
// //     }}
// //   >
// //     {isMobile ? 'Upload Videos (Max 3)' : '(Upload Videos - Max 3 Videos)'}
// //   </Typography>
// //   {propertyVideos.length > 0 && (
// //     <Typography
// //       sx={{
// //         fontSize: isMobile ? '12px' : '14px',
// //         fontWeight: 500,
// //         color: '#4f26ff',
// //         fontFamily: 'Outfit',
// //         textAlign: 'center',
// //         mt: 0.5
// //       }}
// //     >
// //       {propertyVideos.length} {propertyVideos.length === 1 ? 'video' : 'videos'} selected
// //     </Typography>
// //   )}
// //            </Box>
// //           </Box>

// //           {/* Building Name or Project Name */}
// //           <Box sx={{ mb: isMobile ? 2 : 3 }}>
// //             <Typography
// //               sx={{
// //                 fontSize: isMobile ? '14px' : '16px',
// //                 fontWeight: 500,
// //                 color: '#666',
// //                 fontFamily: 'Outfit',
// //                 mb: 1
// //               }}
// //             >
// //               Building Name or Project Name <Box component="span" sx={{ color: '#ff0000' }}>*</Box>
// //             </Typography>
// //             <TextField
// //               fullWidth
// //               placeholder="Enter building name or project name"
// //               value={buildingName}
// //               onChange={(e) => setBuildingName(e.target.value)}
// //               sx={{
// //                 width: isMobile ? '100%' : '450px',
// //                 '& .MuiInputBase-root': {
// //                   height: isMobile ? 44 : 50,
// //                   borderRadius: '8px',
// //                   fontSize: isMobile ? '14px' : '16px',
// //                   fontFamily: 'Outfit',
// //                   border: '1px solid #d0d0d0',
// //                   '&:focus-within': {
// //                     borderColor: '#4f26ff',
// //                     boxShadow: '0 0 0 2px rgba(79, 38, 255, 0.1)'
// //                   }
// //                 },
// //                 '& .MuiInputBase-input::placeholder': {
// //                   color: '#999'
// //                 }
// //               }}
// //             />
// //           </Box>

// //           {/* Area Name */}
// //           <Box sx={{ mb: isMobile ? 2 : 3 }}>
// //             <Typography
// //               sx={{
// //                 fontSize: isMobile ? '14px' : '16px',
// //                 fontWeight: 500,
// //                 color: '#666',
// //                 fontFamily: 'Outfit',
// //                 mb: 1
// //               }}
// //             >
// //               Area Name <Box component="span" sx={{ color: '#ff0000' }}>*</Box>
// //             </Typography>
// //             <TextField
// //               fullWidth
// //               placeholder="Enter area name"
// //               value={areaName}
// //               onChange={(e) => setAreaName(e.target.value)}
// //               sx={{
// //                 width: isMobile ? '100%' : '450px',
// //                 '& .MuiInputBase-root': {
// //                   height: isMobile ? 44 : 50,
// //                   borderRadius: '8px',
// //                   fontSize: isMobile ? '14px' : '16px',
// //                   fontFamily: 'Outfit',
// //                   border: '1px solid #d0d0d0',
// //                   '&:focus-within': {
// //                     borderColor: '#4f26ff',
// //                     boxShadow: '0 0 0 2px rgba(79, 38, 255, 0.1)'
// //                   }
// //                 },
// //                 '& .MuiInputBase-input::placeholder': {
// //                   color: '#999'
// //                 }
// //               }}
// //             />
// //           </Box>

// //           {/* Property Type Selection */}
             
// //           <Box sx={{ mb: isMobile ? 2 : 3 }}>
// //   <Typography
// //     sx={{
// //       fontSize: isMobile ? '14px' : '16px',
// //       fontWeight: 500,
// //       color: '#666',
// //       fontFamily: 'Outfit',
// //       mb: 1
// //     }}
// //   >
// //     Property Type <Box component="span" sx={{ color: '#ff0000' }}>*</Box>
// //   </Typography>

// //   {isMobile ? (
// //     <Grid container spacing={1.5}>
// //       {propertyTypes.map((type) => (
// //         <Grid item xs={6} key={type.id}>
// //           <Card
// //             onClick={() => handlePropertyTypeSelect(type.id)}
// //             sx={{
// //               width: '100%',
// //               height: 60,
// //               display: 'flex',
// //               alignItems: 'center',
// //               justifyContent: 'center',
// //               cursor: 'pointer',
// //               border: selectedPropertyType === type.id
// //                 ? '2px solid #4f26ff'
// //                 : '1px solid #d0d0d0',
// //               backgroundColor: selectedPropertyType === type.id ? '#eeeaff' : 'white',
// //               borderRadius: '8px',
// //               boxSizing: 'border-box',
// //               p: 1,
// //               transition: 'all 0.2s ease',
// //               '&:hover': {
// //                 backgroundColor: selectedPropertyType === type.id ? '#eeeaff' : '#f5f5f5',
// //                 borderColor: '#4f26ff'
// //               },
// //               '&:active': {
// //                 transform: 'scale(0.98)'
// //               }
// //             }}
// //           >
// //             <Typography
// //               sx={{
// //                 fontSize: '12px',
// //                 fontFamily: 'Outfit',
// //                 color: selectedPropertyType === type.id ? '#4f26ff' : 'black',
// //                 fontWeight: selectedPropertyType === type.id ? 500 : 'normal',
// //                 textAlign: 'center',
// //                 lineHeight: 1.2
// //               }}
// //             >
// //               {type.name}
// //             </Typography>
// //           </Card>
// //         </Grid>
// //       ))}
// //     </Grid>
// //   ) : (
// //     <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
// //       {propertyTypes.map((type) => (
// //         <Card
// //           key={type.id}
// //           onClick={() => handlePropertyTypeSelect(type.id)}
// //           sx={{
// //             flex: '0 0 auto',
// //             px: 5,
// //             py: 2,
// //             cursor: 'pointer',
// //             border: selectedPropertyType === type.id
// //               ? '2px solid #4f26ff'
// //               : '1px solid #d0d0d0',
// //             backgroundColor: selectedPropertyType === type.id ? '#eeeaff' : 'white',
// //             borderRadius: '8px',
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'center',
// //             minWidth: '120px',
// //             transition: 'all 0.2s ease',
// //             '&:hover': {
// //               backgroundColor: selectedPropertyType === type.id ? '#eeeaff' : '#f5f5f5',
// //               borderColor: '#4f26ff'
// //             }
// //           }}
// //         >
// //           <Typography
// //             sx={{
// //               fontSize: '13px',
// //               fontFamily: 'Outfit',
// //               color: selectedPropertyType === type.id ? '#4f26ff' : 'black',
// //               fontWeight: selectedPropertyType === type.id ? 500 : 'normal',
// //               textAlign: 'center',
// //               lineHeight: 1.2
// //             }}
// //           >
// //             {type.name}
// //           </Typography>
// //         </Card>
// //       ))}
// //     </Box>
// //   )}
// // </Box>

          

// //           {/* Hub Selection */}
// //           <Box sx={{ mb: isMobile ? 2 : 3 }}>
// //             <Typography sx={{
// //               fontSize: isMobile ? '14px' : '16px',
// //               fontWeight: 500,
// //               color: '#666',
// //               fontFamily: 'Outfit',
// //               mb: 2
// //             }}>
// //               Hub <Box component="span" sx={{ color: '#ff0000' }}>*</Box>
// //             </Typography>

// //             <Box sx={{
// //               display: 'flex',
// //               flexWrap: isMobile ? 'wrap' : 'nowrap',
// //               gap: isMobile ? 1 : 3,
              
// //             }}>
// //               {useOptions.map((option) => (
// //                 <Button
// //                   key={option.id}
// //                   onClick={() => handleUseSelect(option.id)}
// //                   sx={{
// //                     flex: isMobile ? '0 0 48%' : '1',
// //                     maxWidth: isMobile ? 'none' : '150px',
// //                     height: isMobile ? 44 : 45,
// //                     borderRadius: '8px',
// //                     border: '1px solid #d0d0d0',
// //                     backgroundColor: selectedUse === option.id ? '#4f26ff' : 'white',
// //                     color: selectedUse === option.id ? 'white' : 'black',
// //                     fontSize: isMobile ? '14px' : '15px',
// //                     fontFamily: 'Outfit',
// //                     fontWeight: 'normal',
// //                     textTransform: 'none',
// //                     '&:hover': {
// //                       backgroundColor: selectedUse === option.id ? '#4f26ff' : '#f5f5f5',
// //                       borderColor: '#4f26ff'
// //                     },
// //                     '&:active': {
// //                       transform: 'scale(0.98)'
// //                     }
// //                   }}
// //                 >
// //                   {option.label}
// //                 </Button>
// //               ))}
// //             </Box>
// //           </Box>

// //           {/* Property Status Selection */}
// //           <Box sx={{ mb: isMobile ? 2 : 3 }}>
// //             <Typography sx={{
// //               fontSize: isMobile ? '14px' : '16px',
// //               fontWeight: 500,
// //               color: '#666',
// //               fontFamily: 'Outfit',
// //               mb: 2
// //             }}>
// //               Property Status <Box component="span" sx={{ color: '#ff0000' }}>*</Box>
// //             </Typography>

// //             <Box sx={{
// //               display: 'flex',
// //               flexWrap: isMobile ? 'wrap' : 'nowrap',
// //               gap: isMobile ? 1 : 3,
              
// //             }}>
// //               {propertyStatusOptions.map((option) => (
// //                 <Button
// //                   key={option.id}
// //                   onClick={() => handlePropertyStatusSelect(option.id)}
// //                   sx={{
// //                     flex: isMobile ? '0 0 48%' : '1',
// //                     maxWidth: isMobile ? 'none' : '160px',
// //                     height: isMobile ? 44 : 48,
// //                     borderRadius: '8px',
// //                     border: '1px solid #d0d0d0',
// //                     backgroundColor: selectedPropertyStatus === option.id ? '#4f26ff' : 'white',
// //                     color: selectedPropertyStatus === option.id ? 'white' : 'black',
// //                     fontSize: isMobile ? '14px' : '16px',
// //                     fontFamily: 'Outfit',
// //                     fontWeight: 'normal',
// //                     textTransform: 'none',
// //                     '&:hover': {
// //                       backgroundColor: selectedPropertyStatus === option.id ? '#4f26ff' : '#f5f5f5',
// //                       borderColor: '#4f26ff'
// //                     },
// //                     '&:active': {
// //                       transform: 'scale(0.98)'
// //                     }
// //                   }}
// //                 >
// //                   {option.label}
// //                 </Button>
// //               ))}
// //             </Box>
// //           </Box>

// //           {/* Area */}
// //           <Box sx={{ mb: isMobile ? 2 : 3 }}>
// //             <Typography sx={{
// //               fontSize: isMobile ? '14px' : '16px',
// //               fontWeight: 500,
// //               color: '#666',
// //               fontFamily: 'Outfit',
// //               mb: 1
// //             }}>
// //               Area <Box component="span" sx={{ color: '#ff0000' }}>*</Box>
// //             </Typography>
// //             <Grid container spacing={2}>
// //               <Grid item xs={12} sm={6}>
// //                 <Typography sx={{
// //                   fontSize: isMobile ? '12px' : '14px',
// //                   fontWeight: 500,
// //                   color: '#666',
// //                   fontFamily: 'Outfit',
// //                   mb: 0.5
// //                 }}>
// //                   Property Size
// //                 </Typography>
// //                 <TextField
// //                   fullWidth
// //                   placeholder="Enter property size"
// //                   value={propertySize}
// //                   onChange={(e) => setPropertySize(e.target.value)}
// //                   sx={{
// //                     '& .MuiInputBase-root': {
// //                       height: isMobile ? 44 : 50,
// //                       borderRadius: '8px',
// //                       fontSize: isMobile ? '14px' : '16px',
// //                       fontFamily: 'Outfit'
// //                     }
// //                   }}
// //                 />
// //               </Grid>
// //               <Grid item xs={12} sm={6}>
// //                 <Typography sx={{
// //                   fontSize: isMobile ? '12px' : '14px',
// //                   fontWeight: 500,
// //                   color: '#666',
// //                   fontFamily: 'Outfit',
// //                   mb: 0.5
// //                 }}>
// //                   Select Unit
// //                 </Typography>
// //                 <FormControl fullWidth={false}>
// //                   <Select
// //                     value={selectedUnit}
// //                     onChange={(e) => setSelectedUnit(e.target.value)}
// //                     displayEmpty
// //                     IconComponent={() => (
// //                       <Box
// //                         component="img"
// //                         src={downArrowIcon}
// //                         alt="Dropdown Arrow"
// //                         sx={{
// //                           width: isMobile ? 16 : 12,
// //                           height: isMobile ? 16 : 12,
// //                           display: 'block',
// //                         }}
// //                       />
// //                     )}
// //                     sx={{
// //                       width: isMobile ? 120 : 200,
// //                       height: isMobile ? 44 : 50,
// //                       borderRadius: '8px',
// //                       fontSize: isMobile ? '14px' : '16px',
// //                       fontFamily: 'Outfit',
// //                       backgroundColor: 'white',
// //                       '& .MuiSelect-select': {
// //                         pr: '40px',
// //                       },
// //                       '& .MuiSelect-icon': {
// //                         right: 12,
// //                         top: '50%',
// //                         transform: 'translateY(-50%)',
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         pointerEvents: 'none',
// //                       },
// //                     }}
// //                   >
// //                     <MenuItem value="Sq. ft.">Sq. ft.</MenuItem>
// //                     <MenuItem value="Sq. m.">Sq. m.</MenuItem>
// //                     <MenuItem value="Acres">Acres</MenuItem>
// //                   </Select>
// //                 </FormControl>
// //               </Grid>
// //             </Grid>
// //           </Box>

// //           {/* ownership */}
// //           <Box sx={{ mb: isMobile ? 2 : 3 }}>
// //   <Typography
// //     sx={{
// //       fontSize: isMobile ? '14px' : '16px',
// //       fontWeight: 500,
// //       color: '#666',
// //       fontFamily: 'Outfit',
// //       mb: 1
// //     }}
// //   >
// //     Ownership <Box component="span" sx={{ color: '#ff0000' }}>*</Box>
// //   </Typography>

// //   {isMobile ? (
// //     <Grid container spacing={1.5}>
// //       {['Freehold', 'Leasehold', 'Cooperative society', 'Power of attorney'].map((option) => (
// //         <Grid item xs={6} key={option}>
// //           <Card
// //             onClick={() => setSelectedOwnership(option)}
// //             sx={{
// //               width: '100%',
// //               height: 50,
// //               display: 'flex',
// //               alignItems: 'center',
// //               justifyContent: 'center',
// //               cursor: 'pointer',
// //               border: selectedOwnership === option
// //                 ? '2px solid #4f26ff'
// //                 : '1px solid #d0d0d0',
// //               backgroundColor: selectedOwnership === option ? '#eeeaff' : '#fff',
// //               borderRadius: '8px',
// //               boxSizing: 'border-box',
// //               p: 1,
// //               transition: 'all 0.2s ease',
// //               '&:hover': {
// //                 backgroundColor: selectedOwnership === option ? '#eeeaff' : '#f5f5f5',
// //                 borderColor: '#4f26ff'
// //               },
// //               '&:active': {
// //                 transform: 'scale(0.98)'
// //               }
// //             }}
// //           >
// //             <Typography
// //               sx={{
// //                 fontSize: '12px',
// //                 fontFamily: 'Outfit',
// //                 color: selectedOwnership === option ? '#4f26ff' : 'black',
// //                 fontWeight: selectedOwnership === option ? 500 : 'normal',
// //                 textAlign: 'center'
// //               }}
// //             >
// //               {option}
// //             </Typography>
// //           </Card>
// //         </Grid>
// //       ))}
// //     </Grid>
// //   ) : (
// //     <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
// //       {['Freehold', 'Leasehold', 'Cooperative society', 'Power of attorney'].map((option) => (
// //         <Card
// //           key={option}
// //           onClick={() => setSelectedOwnership(option)}
// //           sx={{
// //             px: 3,
// //             py: 1,
// //             cursor: 'pointer',
// //             border: selectedOwnership === option
// //               ? '2px solid #4f26ff'
// //               : '1px solid #d0d0d0',
// //             backgroundColor: selectedOwnership === option ? '#eeeaff' : '#fff',
// //             borderRadius: '8px',
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'center',
// //             minWidth: '160px',
// //             transition: 'all 0.2s ease',
// //             '&:hover': {
// //               backgroundColor: selectedOwnership === option ? '#eeeaff' : '#f5f5f5',
// //               borderColor: '#4f26ff'
// //             }
// //           }}
// //         >
// //           <Typography
// //             sx={{
// //               fontSize: '14px',
// //               fontFamily: 'Outfit',
// //               color: selectedOwnership === option ? '#4f26ff' : 'black',
// //               fontWeight: selectedOwnership === option ? 500 : 'normal',
// //               textAlign: 'center'
// //             }}
// //           >
// //             {option}
// //           </Typography>
// //         </Card>
// //       ))}
// //     </Box>
// //   )}
// // </Box>


// //           {/* Floors Available */}
// //           <Box sx={{ mb: isMobile ? 3 : 4 }}>
// //             <Typography sx={{
// //               fontSize: isMobile ? '14px' : '16px',
// //               fontWeight: 500,
// //               color: '#666',
// //               fontFamily: 'Outfit',
// //               mb: 1
// //             }}>
// //               Floors Available <Box component="span" sx={{ color: '#ff0000' }}>*</Box>
// //             </Typography>
// //             <Grid container spacing={2}>
// //               <Grid item xs={12} sm={6}>
// //                 <Typography sx={{
// //                   fontSize: isMobile ? '12px' : '14px',
// //                   fontWeight: 500,
// //                   color: '#666',
// //                   fontFamily: 'Outfit',
// //                   mb: 0.5
// //                 }}>
// //                   Total floors
// //                 </Typography>
// //                 <TextField
// //                   fullWidth
// //                   placeholder="Enter number of floors"
// //                   value={totalFloors}
// //                   onChange={(e) => setTotalFloors(e.target.value)}
// //                   sx={{
// //                     '& .MuiInputBase-root': {
// //                       height: isMobile ? 44 : 50,
// //                       borderRadius: '8px',
// //                       fontSize: isMobile ? '14px' : '16px',
// //                       fontFamily: 'Outfit'
// //                     }
// //                   }}
// //                 />
// //               </Grid>
// //               <Grid item xs={12} sm={6}>
// //                 <Typography sx={{
// //                   fontSize: isMobile ? '12px' : '14px',
// //                   fontWeight: 500,
// //                   color: '#666',
// //                   fontFamily: 'Outfit',
// //                   mb: 0.5
// //                 }}>
// //                   Select Floor
// //                 </Typography>
// //                 <FormControl fullWidth={false}>
// //                   <Select
// //                     value={selectedFloor}
// //                     onChange={(e) => setSelectedFloor(e.target.value)}
// //                     displayEmpty
// //                     IconComponent={() => (
// //                       <Box
// //                         component="img"
// //                         src={downArrowIcon}
// //                         alt="Dropdown Arrow"
// //                         sx={{
// //                           width: isMobile ? 16 : 12,
// //                           height: isMobile ? 16 : 12,
// //                           display: 'block',
// //                         }}
// //                       />
// //                     )}
// //                     sx={{
// //                       width: isMobile ? 120 : 200,
// //                       height: isMobile ? 44 : 50,
// //                       borderRadius: '8px',
// //                       fontSize: isMobile ? '14px' : '16px',
// //                       fontFamily: 'Outfit',
// //                       backgroundColor: 'white',
// //                       '& .MuiSelect-select': {
// //                         pr: '40px',
// //                       },
// //                       '& .MuiSelect-icon': {
// //                         right: 12,
// //                         top: '50%',
// //                         transform: 'translateY(-50%)',
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         pointerEvents: 'none',
// //                       },
// //                     }}
// //                   >
// //                    <MenuItem value="Mezzine">Mezzine</MenuItem>
// //   <MenuItem value="Ground Floor">Ground Floor</MenuItem>
// //   <MenuItem value="1st Floor">1st Floor</MenuItem>
// //   <MenuItem value="2nd Floor">2nd Floor</MenuItem>
// //   <MenuItem value="3rd Floor">3rd Floor</MenuItem>
// //                   </Select>
// //                 </FormControl>
// //               </Grid>
// //             </Grid>
// //           </Box>

// //           {/* Navigation Buttons */}
// //           <Box sx={{ 
// //             display: 'flex', 
// //             justifyContent: 'space-between', 
// //             flexDirection: isMobile ? 'column' : 'row',
// //             gap: isMobile ? 2 : 2, 
// //             mt: isMobile ? 3 : 4 
// //           }}>
// //             <Button 
// //               onClick={handleBack}
// //               sx={{
// //                 width: isMobile ? '100%' : 150,
// //                 height: isMobile ? 44 : 50,
// //                 backgroundColor: '#c2c2c2',
// //                 color: '#020202',
// //                 borderRadius: '8px',
// //                 fontFamily: 'Outfit',
// //                 fontSize: isMobile ? '16px' : '18px',
// //                 fontWeight: 'normal',
// //                 textTransform: 'none',
// //                 order: isMobile ? 2 : 1,
// //                 '&:hover': {
// //                   backgroundColor: '#b0b0b0'
// //                 },
// //                 '&:active': {
// //                   transform: 'scale(0.98)'
// //                 }
// //               }}
// //             >
// //               Back
// //             </Button>
// //             <Button 
// //               onClick={handleNext}
// //               sx={{
// //                 width: isMobile ? '100%' : 150,
// //                 height: isMobile ? 44 : 50,
// //                 backgroundColor: '#4f26ff',
// //                 color: 'white',
// //                 borderRadius: '8px',
// //                 fontFamily: 'Outfit',
// //                 fontSize: isMobile ? '16px' : '18px',
// //                 fontWeight: 'normal',
// //                 textTransform: 'none',
// //                 order: isMobile ? 1 : 2,
// //                 '&:hover': {
// //                   backgroundColor: '#3d1fd9'
// //                 },
// //                 '&:active': {
// //                   transform: 'scale(0.98)'
// //                 }
// //               }}
// //             >
// //               Next
// //             </Button>
// //           </Box>
// //         </Box>
// //       </Container>
// //     </Box>
// //   );
// // };

// // export default PropertyCommercial;


// //  import React from 'react';
// // import {
// //   Box,
// //   Typography,
// //   TextField,
// //   Grid,
// //   FormControl,
// //   Select,
// //   MenuItem,
// //   FormHelperText,
// //   InputAdornment,
// //   IconButton,
// //   Dialog,
// //   DialogContent,
// //   Popper,
// //   Grow,
// //   Paper,
// //   ClickAwayListener,
// //   List,
// //   ListItem,
// //   ListItemText,
// // } from '@mui/material';
// // import CloudUpload from '@mui/icons-material/CloudUpload';
// // import LinkIcon from '@mui/icons-material/Link';
// // import CloseIcon from '@mui/icons-material/Close';

// // const PropertyCommercial = ({
// //   commercialPropertyTypes,
// //   setCommercialPropertyTypes,
// //   selectedPropertyType,
// //   setSelectedPropertyType,
// //   propertyImages,
// //   setPropertyImages,
// //   imagePreviews,
// //   setImagePreviews,
// //   buildingName,
// //   setBuildingName,
// //   areaName,
// //   setAreaName,
// //   completeAddress,
// //   setCompleteAddress,
// //   propertyDescription,
// //   setPropertyDescription,
// //   socialMediaLink,
// //   setSocialMediaLink,
// //   propertySize,
// //   setPropertySize,
// //   selectedUnit,
// //   setSelectedUnit,
// //   builtUpArea,
// //   setBuiltUpArea,
// //   carpetArea,
// //   setCarpetArea,
// //   zoneType,
// //   setZoneType,
// //   totalFloors,
// //   setTotalFloors,
// //   selectedFloor,
// //   setSelectedFloor,
// //   selectedHub,
// //   setSelectedHub,
// //   selectedOwnership,
// //   setSelectedOwnership,
// //   hubs,
// //   ownerships,
// //   propertyLength,
// //   setPropertyLength,
// //   propertyWidth,
// //   setPropertyWidth,
// //    selectedBHK, 
// //     setSelectedBHK, 
// //      selectedFurnish, 
// //       setSelectedFurnish,  
// //       bhkOptions, 
// //        furnishTypes,
// //   errors,
// //   setErrors,
// //   areaSuggestions,
// //   setAreaSuggestions,
// //   showAreaSuggestions,
// //   setShowAreaSuggestions,
// //   areaAnchorEl,
// //   setAreaAnchorEl,
// //   selectedAreaDetails,
// //   setSelectedAreaDetails,
// //   selectedImageIndex,
// //   setSelectedImageIndex,
// //   previewOpen,
// //   setPreviewOpen,
// //   validateAlphanumeric,
// //   validateNumber,
// //   validateAlphanumericField,
// //   validateSocialMediaLink,
// //   location,
// // }) => {
// //   const selectedType = commercialPropertyTypes.find(type => type.id === selectedPropertyType);
// //   const isOffice = selectedType?.id === 'office';
// //   const isShowroom = selectedType?.id === 'showroom';
// //   const isRetailShop = selectedType?.id === 'retail-shop';
// //   const isWarehouse = selectedType?.id === 'warehouse';
// //   const isPlot = selectedType?.id === 'plot';
// //   const isFarmhouse = selectedType?.id === 'farm-house';  // ✅ ADD THIS LINE

// //   const handlePropertyTypeSelect = (typeId) => {
// //     setSelectedPropertyType(typeId);
// //     const updatedTypes = commercialPropertyTypes.map(type => ({
// //       ...type,
// //       selected: type.id === typeId
// //     }));
// //     setCommercialPropertyTypes(updatedTypes);
// //   };

// //   const handleImageUpload = (event) => {
// //     const files = event.target.files;
// //     if (!files || files.length === 0) return;
// //     if (files.length > 10) {
// //       alert("You can only upload up to 10 images");
// //       return;
// //     }

// //     const validFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
// //     if (validFiles.length !== files.length) {
// //       alert("Only image files are allowed (JPEG, PNG, GIF, etc.)");
// //       return;
// //     }

// //     const newPreviews = [];
// //     const fileProcessPromises = validFiles.map(file => {
// //       return new Promise((resolve) => {
// //         const reader = new FileReader();
// //         reader.onload = (e) => {
// //           newPreviews.push(e.target.result);
// //           resolve();
// //         };
// //         reader.onerror = () => {
// //           console.error(`Failed to read file: ${file.name}`);
// //           resolve();
// //         };
// //         reader.readAsDataURL(file);
// //       });
// //     });

// //     Promise.all(fileProcessPromises).then(() => {
// //       const updatedPreviews = [...imagePreviews, ...newPreviews];
// //       const updatedFiles = [...propertyImages, ...validFiles];
// //       setImagePreviews(updatedPreviews);
// //       setPropertyImages(updatedFiles);
// //       localStorage.setItem('propertyImagePreviews', JSON.stringify(updatedPreviews));
// //     });
// //   };

// //   const handleAreaNameChange = (e) => {
// //     const value = e.target.value;
// //     setAreaName(value);
// //     setAreaAnchorEl(e.currentTarget);
// //     if (!value) {
// //       setErrors(prev => ({...prev, areaName: 'Area Name is required'}));
// //     } else if (value.trim().length < 1) {
// //       setErrors(prev => ({...prev, areaName: 'Area Name must be at least 3 characters'}));
// //     } else {
// //       setErrors(prev => ({...prev, areaName: ''}));
// //     }
// //   };

// //   const handleSelectArea = (area) => {
// //     setAreaName(area.area);
// //     setSelectedAreaDetails({
// //       name: area.area,
// //       address: area.address,
// //       location: area.location
// //     });
// //     setAreaAnchorEl(null);
// //     setShowAreaSuggestions(false);
// //     setErrors(prev => ({...prev, areaName: ''}));
// //   };

// //   const handleAreaClickAway = () => {
// //     setShowAreaSuggestions(false);
// //   };

// //   const fetchAreaSuggestions = async (query, city) => {
// //     if (query.length < 1 || !city) return;
// //     try {
// //       const response = await fetch(`https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`);
// //       const data = await response.json();
// //       if (data.success && data.areas && data.areas.length > 0) {
// //         const transformedAreas = data.areas.map(area => ({
// //           area: area.name,
// //           address: area.address,
// //           location: area.location
// //         }));
// //         setAreaSuggestions(transformedAreas);
// //         setShowAreaSuggestions(true);
// //       } else {
// //         setAreaSuggestions([]);
// //         setShowAreaSuggestions(false);
// //       }
// //     } catch (error) {
// //       console.error('Error fetching area suggestions:', error);
// //       setAreaSuggestions([]);
// //       setShowAreaSuggestions(false);
// //     }
// //   };

// //   React.useEffect(() => {
// //     if (areaName.trim().length > 0 && location.state?.location) {
// //       fetchAreaSuggestions(areaName, location.state.location);
// //     } else {
// //       setAreaSuggestions([]);
// //       setShowAreaSuggestions(false);
// //     }
// //   }, [areaName, location.state?.location]);

// //   return (
// //     <Box>
// //       {/* Property Type & Upload Images */}
// //       <Grid container spacing={2} sx={{ mb: 3 }}>
// //         <Grid item xs={12} sm="auto">
// //           <Box sx={{ width: '410px', maxWidth: '100%' }}>
// //             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //               Property Type <span style={{ color: '#d32f2f' }}>*</span>
// //             </Typography>
// //             <FormControl fullWidth size="small">
// //               <Select
// //                 value={selectedPropertyType}
// //                 onChange={(e) => handlePropertyTypeSelect(e.target.value)}
// //                 displayEmpty
// //                 sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                 renderValue={(selected) => {
// //                   const selectedTypeObj = commercialPropertyTypes.find(type => type.id === selected);
// //                   if (!selectedTypeObj) {
// //                     return <em style={{ color: '#999' }}>Select Property Type</em>;
// //                   }
// //                   return (
// //                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
// //                       <Box component="img" src={selectedTypeObj.icon} alt={selectedTypeObj.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
// //                       <Typography sx={{ fontFamily: 'Outfit', fontSize: '13px' }}>
// //                         {selectedTypeObj.name}
// //                       </Typography>
// //                     </Box>
// //                   );
// //                 }}
// //               >
// //                 {commercialPropertyTypes.map((type) => (
// //                   <MenuItem key={type.id} value={type.id}>
// //                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
// //                       <Box component="img" src={type.icon} alt={type.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
// //                       {type.name}
// //                     </Box>
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           </Box>
// //         </Grid>

// //         <Grid item xs={12} sm="auto">
// //           <Box sx={{ width: '410px', maxWidth: '100%' }}>
// //             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //               Upload Images
// //             </Typography>
// //             <Box
// //               sx={{
// //                 height: 36,
// //                 border: '2px dashed #d0d0d0',
// //                 borderRadius: 1.5,
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 justifyContent: 'center',
// //                 cursor: 'pointer',
// //                 transition: 'all 0.2s ease',
// //                 '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#1976d2' },
// //               }}
// //               onClick={() => document.getElementById('property-images').click()}
// //             >
// //               <input
// //                 type="file"
// //                 id="property-images"
// //                 multiple
// //                 accept="image/*"
// //                 style={{ display: 'none' }}
// //                 onChange={handleImageUpload}
// //               />
// //               <CloudUpload sx={{ width: 24, height: 24, mr: 1, color: '#1976d2' }} />
// //               <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#666', fontFamily: 'Outfit' }}>
// //                 Upload (Max 10)
// //               </Typography>
// //             </Box>
// //           </Box>
// //         </Grid>
// //       </Grid>

// //       {/* Display uploaded images */}
// //       {imagePreviews && imagePreviews.length > 0 && (
// //         <Box sx={{ mb: 3 }}>
// //           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 1 }}>
// //             {imagePreviews.length} {imagePreviews.length === 1 ? 'image' : 'images'} uploaded
// //           </Typography>
// //           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, p: 2, border: '1px solid #e0e0e0', borderRadius: 1.5, backgroundColor: '#fafafa' }}>
// //             {imagePreviews.map((preview, index) => (
// //               <Box
// //                 key={`img-preview-${index}`}
// //                 sx={{
// //                   position: 'relative',
// //                   width: '100px',
// //                   height: '100px',
// //                   borderRadius: 1.5,
// //                   overflow: 'hidden',
// //                   border: '2px solid #e0e0e0',
// //                   cursor: 'pointer',
// //                   flexShrink: 0,
// //                   '&:hover': { borderColor: '#1976d2' }
// //                 }}
// //                 onClick={() => {
// //                   setSelectedImageIndex(index);
// //                   setPreviewOpen(true);
// //                 }}
// //               >
// //                 <Box
// //                   component="img"
// //                   src={preview}
// //                   alt={`Preview ${index + 1}`}
// //                   sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
// //                 />
// //                 <IconButton
// //                   size="small"
// //                   sx={{
// //                     position: 'absolute',
// //                     top: -8,
// //                     right: -8,
// //                     bgcolor: '#ff4444',
// //                     color: 'white',
// //                     width: 24,
// //                     height: 24,
// //                     fontSize: '14px',
// //                     '&:hover': { bgcolor: '#cc0000' }
// //                   }}
// //                   onClick={(e) => {
// //                     e.stopPropagation();
// //                     const newPreviews = [...imagePreviews];
// //                     const newFiles = [...propertyImages];
// //                     newPreviews.splice(index, 1);
// //                     newFiles.splice(index, 1);
// //                     setImagePreviews(newPreviews);
// //                     setPropertyImages(newFiles);
// //                     if (newPreviews.length > 0) {
// //                       localStorage.setItem('propertyImagePreviews', JSON.stringify(newPreviews));
// //                     } else {
// //                       localStorage.removeItem('propertyImagePreviews');
// //                     }
// //                   }}
// //                 >
// //                   ×
// //                 </IconButton>
// //               </Box>
// //             ))}
// //           </Box>
// //         </Box>
// //       )}

// //       {/* Building Name & Area Name */}
// //       <Grid container spacing={2} sx={{ mb: 3 }}>
// //         <Grid item xs={12} sm="auto">
// //           <Box sx={{ width: '410px', maxWidth: '100%' }}>
// //             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //               Building/Project Name <span style={{ color: '#d32f2f' }}>*</span>
// //             </Typography>
// //             <TextField
// //               id="buildingName"
// //               fullWidth
// //               size="small"
// //               placeholder="Enter building name"
// //               value={buildingName}
// //               onChange={(e) => {
// //                 setBuildingName(e.target.value);
// //                 setErrors(prev => ({...prev, buildingName: validateAlphanumeric(e.target.value, "Building name")}));
// //               }}
// //               error={!!errors.buildingName}
// //               helperText={errors.buildingName}
// //               sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //             />
// //           </Box>
// //         </Grid>

// //         <Grid item xs={12} sm="auto">
// //           <Box sx={{ width: '410px', maxWidth: '100%' }}>
// //             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //               Area Name <span style={{ color: '#d32f2f' }}>*</span>
// //             </Typography>
// //             <ClickAwayListener onClickAway={handleAreaClickAway}>
// //               <Box sx={{ position: 'relative' }}>
// //                 <TextField
// //                   id="areaName"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter area name"
// //                   value={areaName}
// //                   onChange={handleAreaNameChange}
// //                   error={!!errors.areaName}
// //                   helperText={errors.areaName}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //                 {showAreaSuggestions && areaSuggestions.length > 0 && (
// //                   <Popper
// //                     open={showAreaSuggestions}
// //                     anchorEl={areaAnchorEl}
// //                     placement="bottom-start"
// //                     transition
// //                     style={{ width: areaAnchorEl ? areaAnchorEl.clientWidth : 'auto', zIndex: 1300 }}
// //                   >
// //                     {({ TransitionProps }) => (
// //                       <Grow {...TransitionProps} timeout={200}>
// //                         <Paper elevation={3} sx={{ maxHeight: 200, overflow: 'auto', mt: 0.5, border: '1px solid #e0e0e0', borderRadius: 1 }}>
// //                           <List dense>
// //                             {areaSuggestions.map((area, index) => (
// //                               <ListItem
// //                                 key={index}
// //                                 button
// //                                 onClick={() => handleSelectArea(area)}
// //                                 sx={{ py: 0.8, '&:hover': { backgroundColor: '#f5f5f5' } }}
// //                               >
// //                                 <ListItemText
// //                                   primary={area.area}
// //                                   primaryTypographyProps={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '13px' }}
// //                                 />
// //                               </ListItem>
// //                             ))}
// //                           </List>
// //                         </Paper>
// //                       </Grow>
// //                     )}
// //                   </Popper>
// //                 )}
// //               </Box>
// //             </ClickAwayListener>
// //           </Box>
// //         </Grid>
// //       </Grid>

// //       {/* Complete Address & Description */}
// //       <Grid container spacing={2} sx={{ mb: 3 }}>
// //         <Grid item xs={12} sm="auto">
// //           <Box sx={{ width: '400px', maxWidth: '100%' }}>
// //             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //               Complete Address <span style={{ color: '#d32f2f' }}>*</span>
// //             </Typography>
// //             <TextField
// //               id="completeAddress"
// //               fullWidth
// //               size="small"
// //               multiline
// //               rows={3}
// //               placeholder="Enter address (max 5 digits allowed)"
// //               value={completeAddress}
// //               onChange={(e) => {
// //                 const value = e.target.value;
// //                 const numbers = value.replace(/\D/g, '');
// //                 if (numbers.length <= 5) {
// //                   setCompleteAddress(value);
// //                   setErrors(prev => ({...prev, completeAddress: validateAlphanumericField(value, "Complete address", true)}));
// //                 }
// //               }}
// //               error={!!errors.completeAddress}
// //               helperText={errors.completeAddress}
// //               sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //             />
// //           </Box>
// //         </Grid>

// //         <Grid item xs={12} sm="auto">
// //           <Box sx={{ width: '400px', maxWidth: '100%' }}>
// //             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //               Description <span style={{ color: '#999', fontSize: '11px' }}>(Optional - max 5 digits)</span>
// //             </Typography>
// //             <TextField
// //                            id="propertyDescription"
// //               fullWidth
// //               size="small"
// //               multiline
// //               rows={3}
// //               placeholder="Enter description (max 5 digits allowed)"
// //               value={propertyDescription}
// //               onChange={(e) => {
// //                 const value = e.target.value;
// //                 const numbers = value.replace(/\D/g, '');
// //                 if (numbers.length <= 5) {
// //                   setPropertyDescription(value);
// //                   if (value) {
// //                     setErrors(prev => ({...prev, propertyDescription: validateAlphanumericField(value, "Description", false)}));
// //                   } else {
// //                     setErrors(prev => ({...prev, propertyDescription: ''}));
// //                   }
// //                 }
// //               }}
// //               error={!!errors.propertyDescription}
// //               helperText={errors.propertyDescription}
// //               sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //             />
// //           </Box>
// //         </Grid>
// //       </Grid>

// //       {/* ✅ COMMERCIAL OFFICE FIELDS */}
// //       {isOffice && (
// //         <>
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '410px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="socialMediaLink"
// //                   fullWidth
// //                   size="small"
// //                   type="url"
// //                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
// //                   value={socialMediaLink}
// //                   onChange={(e) => {
// //                     setSocialMediaLink(e.target.value);
// //                     if (e.target.value) {
// //                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
// //                     } else {
// //                       setErrors(prev => ({...prev, socialMediaLink: ''}));
// //                     }
// //                   }}
// //                   error={!!errors.socialMediaLink}
// //                   helperText={errors.socialMediaLink}
// //                   InputProps={{
// //                     startAdornment: (
// //                       <InputAdornment position="start">
// //                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
// //                       </InputAdornment>
// //                     ),
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Property Size */}
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '280px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
// //                 </Typography>
// //                 <TextField
// //                   id="propertySize"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter property size"
// //                   value={propertySize}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setPropertySize(value);
// //                     setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
// //                   }}
// //                   error={!!errors.propertySize}
// //                   helperText={errors.propertySize}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Built-up Area and Zone Type (Optional) */}
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="builtUpArea"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter built-up area"
// //                   value={builtUpArea}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setBuiltUpArea(value);
// //                   }}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>

// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="zoneType"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter zone type"
// //                   value={zoneType}
// //                   onChange={(e) => setZoneType(e.target.value)}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Available Floors Section */}
// //           <Box sx={{ mb: 3 }}>
// //             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
// //               Available Floors <span style={{ color: '#d32f2f' }}>*</span>
// //             </Typography>
// //             <Grid container spacing={2}>
// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Total Floors
// //                   </Typography>
// //                   <TextField
// //                     id="totalFloors"
// //                     fullWidth
// //                     size="small"
// //                     placeholder="Enter total floors"
// //                     value={totalFloors}
// //                     onChange={(e) => {
// //                       const value = e.target.value.replace(/[^0-9]/g, '');
// //                       setTotalFloors(value);
// //                       setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
// //                     }}
// //                     error={!!errors.totalFloors}
// //                     helperText={errors.totalFloors}
// //                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                   />
// //                 </Box>
// //               </Grid>

// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Select Floor
// //                   </Typography>
// //                   <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
// //                     <Select
// //                       id="selectedFloor"
// //                       value={selectedFloor}
// //                       onChange={(e) => {
// //                         setSelectedFloor(e.target.value);
// //                         setErrors({...errors, selectedFloor: ''});
// //                       }}
// //                       displayEmpty
// //                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                     >
// //                       <MenuItem value="" disabled>Select Floor</MenuItem>
// //                       {[...Array(20)].map((_, i) => (
// //                         <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
// //                           {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
// //                         </MenuItem>
// //                       ))}
// //                     </Select>
// //                     {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
// //                   </FormControl>
// //                 </Box>
// //               </Grid>

// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '200px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Ownership
// //                   </Typography>
// //                   <FormControl fullWidth size="small">
// //                     <Select
// //                       value={selectedOwnership}
// //                       onChange={(e) => setSelectedOwnership(e.target.value)}
// //                       displayEmpty
// //                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                     >
// //                       <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
// //                       {ownerships.map((own) => (
// //                         <MenuItem key={own} value={own}>{own}</MenuItem>
// //                       ))}
// //                     </Select>
// //                   </FormControl>
// //                 </Box>
// //               </Grid>

// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '200px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Hub
// //                   </Typography>
// //                   <FormControl fullWidth size="small">
// //                     <Select
// //                       value={selectedHub}
// //                       onChange={(e) => setSelectedHub(e.target.value)}
// //                       displayEmpty
// //                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                     >
// //                       <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
// //                       {hubs.map((hub) => (
// //                         <MenuItem key={hub} value={hub}>{hub}</MenuItem>
// //                       ))}
// //                     </Select>
// //                   </FormControl>
// //                 </Box>
// //               </Grid>
// //             </Grid>
// //           </Box>
// //         </>
// //       )}

// //       {/* ✅ COMMERCIAL SHOWROOM & RETAIL SHOP FIELDS */}
// //       {(isShowroom || isRetailShop) && (
// //         <>
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '410px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="socialMediaLink"
// //                   fullWidth
// //                   size="small"
// //                   type="url"
// //                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
// //                   value={socialMediaLink}
// //                   onChange={(e) => {
// //                     setSocialMediaLink(e.target.value);
// //                     if (e.target.value) {
// //                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
// //                     } else {
// //                       setErrors(prev => ({...prev, socialMediaLink: ''}));
// //                     }
// //                   }}
// //                   error={!!errors.socialMediaLink}
// //                   helperText={errors.socialMediaLink}
// //                   InputProps={{
// //                     startAdornment: (
// //                       <InputAdornment position="start">
// //                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
// //                       </InputAdornment>
// //                     ),
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Property Size */}
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '410px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
// //                 </Typography>
// //                 <TextField
// //                   id="propertySize"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter property size"
// //                   value={propertySize}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setPropertySize(value);
// //                     setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
// //                   }}
// //                   error={!!errors.propertySize}
// //                   helperText={errors.propertySize}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Built-up Area and Carpet Area (Optional) */}
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="builtUpArea"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter built-up area"
// //                   value={builtUpArea}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setBuiltUpArea(value);
// //                   }}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>

// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="carpetArea"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter carpet area"
// //                   value={carpetArea}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setCarpetArea(value);
// //                   }}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Available Floors Section */}
// //           <Box sx={{ mb: 3 }}>
// //             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
// //               Available Floors <span style={{ color: '#d32f2f' }}>*</span>
// //             </Typography>
// //             <Grid container spacing={2}>
// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Total Floors
// //                   </Typography>
// //                   <TextField
// //                     id="totalFloors"
// //                     fullWidth
// //                     size="small"
// //                     placeholder="Enter total floors"
// //                     value={totalFloors}
// //                     onChange={(e) => {
// //                       const value = e.target.value.replace(/[^0-9]/g, '');
// //                       setTotalFloors(value);
// //                       setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
// //                     }}
// //                     error={!!errors.totalFloors}
// //                     helperText={errors.totalFloors}
// //                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                   />
// //                 </Box>
// //               </Grid>

// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Select Floor
// //                   </Typography>
// //                   <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
// //                     <Select
// //                       id="selectedFloor"
// //                       value={selectedFloor}
// //                       onChange={(e) => {
// //                         setSelectedFloor(e.target.value);
// //                         setErrors({...errors, selectedFloor: ''});
// //                       }}
// //                       displayEmpty
// //                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                     >
// //                       <MenuItem value="" disabled>Select Floor</MenuItem>
// //                       {[...Array(20)].map((_, i) => (
// //                         <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
// //                           {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
// //                         </MenuItem>
// //                       ))}
// //                     </Select>
// //                     {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
// //                   </FormControl>
// //                 </Box>
// //               </Grid>

// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '200px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Ownership
// //                   </Typography>
// //                   <FormControl fullWidth size="small">
// //                     <Select
// //                       value={selectedOwnership}
// //                       onChange={(e) => setSelectedOwnership(e.target.value)}
// //                       displayEmpty
// //                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                     >
// //                       <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
// //                       {ownerships.map((own) => (
// //                         <MenuItem key={own} value={own}>{own}</MenuItem>
// //                       ))}
// //                     </Select>
// //                   </FormControl>
// //                 </Box>
// //               </Grid>

// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '200px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Hub
// //                   </Typography>
// //                   <FormControl fullWidth size="small">
// //                     <Select
// //                       value={selectedHub}
// //                       onChange={(e) => setSelectedHub(e.target.value)}
// //                       displayEmpty
// //                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                     >
// //                       <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
// //                       {hubs.map((hub) => (
// //                         <MenuItem key={hub} value={hub}>{hub}</MenuItem>
// //                       ))}
// //                     </Select>
// //                   </FormControl>
// //                 </Box>
// //               </Grid>
// //             </Grid>
// //           </Box>
// //         </>
// //       )}

// //       {/* ✅ COMMERCIAL WAREHOUSE FIELDS */}
// //       {isWarehouse && (
// //         <>
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '410px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="socialMediaLink"
// //                   fullWidth
// //                   size="small"
// //                   type="url"
// //                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
// //                   value={socialMediaLink}
// //                   onChange={(e) => {
// //                     setSocialMediaLink(e.target.value);
// //                     if (e.target.value) {
// //                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
// //                     } else {
// //                       setErrors(prev => ({...prev, socialMediaLink: ''}));
// //                     }
// //                   }}
// //                   error={!!errors.socialMediaLink}
// //                   helperText={errors.socialMediaLink}
// //                   InputProps={{
// //                     startAdornment: (
// //                       <InputAdornment position="start">
// //                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
// //                       </InputAdornment>
// //                     ),
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Property Size */}
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '410px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
// //                 </Typography>
// //                 <TextField
// //                   id="propertySize"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter property size"
// //                   value={propertySize}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setPropertySize(value);
// //                     setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
// //                   }}
// //                   error={!!errors.propertySize}
// //                   helperText={errors.propertySize}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Zone Type, Built-up Area, Carpet Area (All Optional) */}
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="zoneType"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter zone type"
// //                   value={zoneType}
// //                   onChange={(e) => setZoneType(e.target.value)}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>

// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="builtUpArea"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter built-up area"
// //                   value={builtUpArea}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setBuiltUpArea(value);
// //                   }}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>

// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="carpetArea"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter carpet area"
// //                   value={carpetArea}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setCarpetArea(value);
// //                   }}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Available Floors Section */}
// //           <Box sx={{ mb: 3 }}>
// //             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
// //               Available Floors <span style={{ color: '#d32f2f' }}>*</span>
// //             </Typography>
// //             <Grid container spacing={2}>
// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Total Floors
// //                   </Typography>
// //                   <TextField
// //                                         id="totalFloors"
// //                     fullWidth
// //                     size="small"
// //                     placeholder="Enter total floors"
// //                     value={totalFloors}
// //                     onChange={(e) => {
// //                       const value = e.target.value.replace(/[^0-9]/g, '');
// //                       setTotalFloors(value);
// //                       setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
// //                     }}
// //                     error={!!errors.totalFloors}
// //                     helperText={errors.totalFloors}
// //                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                   />
// //                 </Box>
// //               </Grid>

// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Select Floor
// //                   </Typography>
// //                   <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
// //                     <Select
// //                       id="selectedFloor"
// //                       value={selectedFloor}
// //                       onChange={(e) => {
// //                         setSelectedFloor(e.target.value);
// //                         setErrors({...errors, selectedFloor: ''});
// //                       }}
// //                       displayEmpty
// //                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                     >
// //                       <MenuItem value="" disabled>Select Floor</MenuItem>
// //                       {[...Array(20)].map((_, i) => (
// //                         <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
// //                           {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
// //                         </MenuItem>
// //                       ))}
// //                     </Select>
// //                     {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
// //                   </FormControl>
// //                 </Box>
// //               </Grid>

// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '200px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Ownership
// //                   </Typography>
// //                   <FormControl fullWidth size="small">
// //                     <Select
// //                       value={selectedOwnership}
// //                       onChange={(e) => setSelectedOwnership(e.target.value)}
// //                       displayEmpty
// //                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                     >
// //                       <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
// //                       {ownerships.map((own) => (
// //                         <MenuItem key={own} value={own}>{own}</MenuItem>
// //                       ))}
// //                     </Select>
// //                   </FormControl>
// //                 </Box>
// //               </Grid>

// //               <Grid item xs={12} sm="auto">
// //                 <Box sx={{ width: '200px', maxWidth: '100%' }}>
// //                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                     Hub
// //                   </Typography>
// //                   <FormControl fullWidth size="small">
// //                     <Select
// //                       value={selectedHub}
// //                       onChange={(e) => setSelectedHub(e.target.value)}
// //                       displayEmpty
// //                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                     >
// //                       <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
// //                       {hubs.map((hub) => (
// //                         <MenuItem key={hub} value={hub}>{hub}</MenuItem>
// //                       ))}
// //                     </Select>
// //                   </FormControl>
// //                 </Box>
// //               </Grid>
// //             </Grid>
// //           </Box>
// //         </>
// //       )}

// //       {/* ✅ COMMERCIAL PLOT FIELDS */}
// //       {isPlot && (
// //         <>
// //           {/* Social Media Link */}
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '410px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="socialMediaLink"
// //                   fullWidth
// //                   size="small"
// //                   type="url"
// //                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
// //                   value={socialMediaLink}
// //                   onChange={(e) => {
// //                     setSocialMediaLink(e.target.value);
// //                     if (e.target.value) {
// //                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
// //                     } else {
// //                       setErrors(prev => ({...prev, socialMediaLink: ''}));
// //                     }
// //                   }}
// //                   error={!!errors.socialMediaLink}
// //                   helperText={errors.socialMediaLink}
// //                   InputProps={{
// //                     startAdornment: (
// //                       <InputAdornment position="start">
// //                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
// //                       </InputAdornment>
// //                     ),
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Property Size, Zone Type, Ownership */}
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
// //                 </Typography>
// //                 <Box sx={{ display: 'flex', gap: 1 }}>
// //                   <TextField
// //                     id="propertySize"
// //                     fullWidth
// //                     size="small"
// //                     placeholder="Enter size"
// //                     value={propertySize}
// //                     onChange={(e) => {
// //                       const value = e.target.value.replace(/[^0-9]/g, '');
// //                       setPropertySize(value);
// //                       setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
// //                     }}
// //                     error={!!errors.propertySize}
// //                     helperText={errors.propertySize}
// //                     sx={{ 
// //                       flex: 1,
// //                       '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
// //                     }}
// //                   />
// //                   <FormControl size="small" sx={{ minWidth: 100 }}>
// //                     <Select
// //                       value={selectedUnit}
// //                       onChange={(e) => setSelectedUnit(e.target.value)}
// //                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                     >
// //                       <MenuItem value="sq.yards">Sq.Yards</MenuItem>
// //                       <MenuItem value="acres">Acres</MenuItem>
// //                     </Select>
// //                   </FormControl>
// //                 </Box>
// //               </Box>
// //             </Grid>

// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="zoneType"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter zone type"
// //                   value={zoneType}
// //                   onChange={(e) => setZoneType(e.target.value)}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>

// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <FormControl fullWidth size="small">
// //                   <Select
// //                     value={selectedOwnership}
// //                     onChange={(e) => setSelectedOwnership(e.target.value)}
// //                     displayEmpty
// //                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                   >
// //                     <MenuItem value=""><em>Select Ownership</em></MenuItem>
// //                     {ownerships.map((own) => (
// //                       <MenuItem key={own} value={own}>{own}</MenuItem>
// //                     ))}
// //                   </Select>
// //                 </FormControl>
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Length and Width */}
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Length <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="propertyLength"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter length"
// //                   value={propertyLength}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setPropertyLength(value);
// //                   }}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>

// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Width <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="propertyWidth"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter width"
// //                   value={propertyWidth}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setPropertyWidth(value);
// //                   }}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>
// //         </>
// //       )}

// //              {/* ✅ COMMERCIAL FARMHOUSE FIELDS */}
// //       {isFarmhouse && (
// //         <>
// //           {/* Social Media Link, BHK, Furnish Type */}
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '300px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
// //                 </Typography>
// //                 <TextField
// //                   id="socialMediaLink"
// //                   fullWidth
// //                   size="small"
// //                   type="url"
// //                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
// //                   value={socialMediaLink}
// //                   onChange={(e) => {
// //                     setSocialMediaLink(e.target.value);
// //                     if (e.target.value) {
// //                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
// //                     } else {
// //                       setErrors(prev => ({...prev, socialMediaLink: ''}));
// //                     }
// //                   }}
// //                   error={!!errors.socialMediaLink}
// //                   helperText={errors.socialMediaLink}
// //                   InputProps={{
// //                     startAdornment: (
// //                       <InputAdornment position="start">
// //                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
// //                       </InputAdornment>
// //                     ),
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>

// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '180px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   BHK <span style={{ color: '#d32f2f' }}>*</span>
// //                 </Typography>
// //                 <FormControl fullWidth size="small" error={!!errors.bhk}>
// //                   <Select
// //                     value={selectedBHK}
// //                     onChange={(e) => {
// //                       setSelectedBHK(e.target.value);
// //                       setErrors({...errors, bhk: ''});
// //                     }}
// //                     displayEmpty
// //                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                   >
// //                     <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
// //                     {bhkOptions.map((option) => (
// //                       <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
// //                     ))}
// //                   </Select>
// //                   {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
// //                 </FormControl>
// //               </Box>
// //             </Grid>

// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '230px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
// //                 </Typography>
// //                 <FormControl fullWidth size="small" error={!!errors.furnish}>
// //                   <Select
// //                     value={selectedFurnish}
// //                     onChange={(e) => {
// //                       setSelectedFurnish(e.target.value);
// //                       setErrors({...errors, furnish: ''});
// //                     }}
// //                     displayEmpty
// //                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
// //                   >
// //                     <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
// //                     {furnishTypes.map((type) => (
// //                       <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
// //                     ))}
// //                   </Select>
// //                   {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
// //                 </FormControl>
// //               </Box>
// //             </Grid>
// //           </Grid>

// //           {/* Built-up Area (MANDATORY) and Property Size */}
// //           <Grid container spacing={2} sx={{ mb: 3 }}>
// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
// //                 </Typography>
// //                 <TextField
// //                   id="builtUpArea"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter built-up area"
// //                   value={builtUpArea}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setBuiltUpArea(value);
// //                     setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
// //                   }}
// //                   error={!!errors.builtUpArea}
// //                   helperText={errors.builtUpArea}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>

// //             <Grid item xs={12} sm="auto">
// //               <Box sx={{ width: '270px', maxWidth: '100%' }}>
// //                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
// //                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
// //                 </Typography>
// //                 <TextField
// //                   id="propertySize"
// //                   fullWidth
// //                   size="small"
// //                   placeholder="Enter property size"
// //                   value={propertySize}
// //                   onChange={(e) => {
// //                     const value = e.target.value.replace(/[^0-9]/g, '');
// //                     setPropertySize(value);
// //                     setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
// //                   }}
// //                   error={!!errors.propertySize}
// //                   helperText={errors.propertySize}
// //                   InputProps={{
// //                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
// //                   }}
// //                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
// //                 />
// //               </Box>
// //             </Grid>
// //           </Grid>
// //         </>
// //       )}

   


// //       {/* Image Preview Dialog */}
// //       {imagePreviews.length > 0 && (
// //         <Dialog
// //           open={previewOpen}
// //           onClose={() => setPreviewOpen(false)}
// //           maxWidth="md"
// //           fullWidth
// //           sx={{ '& .MuiDialog-paper': { borderRadius: '12px', overflow: 'hidden', bgcolor: 'black' } }}
// //         >
// //           <DialogContent sx={{ p: 0, position: 'relative' }}>
// //             <Box
// //               component="img"
// //               src={imagePreviews[selectedImageIndex]}
// //               alt={`Image ${selectedImageIndex + 1}`}
// //               sx={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain' }}
// //             />
// //             <IconButton
// //               onClick={() => setPreviewOpen(false)}
// //               sx={{
// //                 position: 'absolute',
// //                 top: 8,
// //                 right: 8,
// //                 bgcolor: 'rgba(255, 255, 255, 0.3)',
// //                 color: 'white',
// //                 '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
// //               }}
// //             >
// //               <CloseIcon />
// //             </IconButton>
// //             {imagePreviews.length > 1 && (
// //               <>
// //                 <IconButton
// //                   onClick={() => setSelectedImageIndex(prev => (prev > 0 ? prev - 1 : imagePreviews.length - 1))}
// //                   sx={{
// //                     position: 'absolute',
// //                     left: 8,
// //                     top: '50%',
// //                     transform: 'translateY(-50%)',
// //                     bgcolor: 'rgba(255, 255, 255, 0.3)',
// //                     color: 'white',
// //                     '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
// //                   }}
// //                 >
// //                   ‹
// //                 </IconButton>
// //                 <IconButton
// //                   onClick={() => setSelectedImageIndex(prev => (prev < imagePreviews.length - 1 ? prev + 1 : 0))}
// //                   sx={{
// //                     position: 'absolute',
// //                     right: 8,
// //                     top: '50%',
// //                     transform: 'translateY(-50%)',
// //                     bgcolor: 'rgba(255, 255, 255, 0.3)',
// //                     color: 'white',
// //                     '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
// //                   }}
// //                 >
// //                   ›
// //                 </IconButton>
// //                 <Box
// //                   sx={{
// //                     position: 'absolute',
// //                     bottom: 16,
// //                     left: '50%',
// //                     transform: 'translateX(-50%)',
// //                     bgcolor: 'rgba(0, 0, 0, 0.7)',
// //                     color: 'white',
// //                     px: 2,
// //                     py: 1,
// //                     borderRadius: '16px',
// //                     fontSize: '14px',
// //                     fontFamily: 'Outfit'
// //                   }}
// //                 >
// //                   {selectedImageIndex + 1} / {imagePreviews.length}
// //                 </Box>
// //               </>
// //             )}
// //           </DialogContent>
// //         </Dialog>
// //       )}
// //     </Box>
// //   );
// // };

// // export default PropertyCommercial;



// import React from 'react';
// import {
//   Box,
//   Typography,
//   TextField,
//   Grid,
//   FormControl,
//   Select,
//   MenuItem,
//   FormHelperText,
//   InputAdornment,
//   IconButton,
//   Dialog,
//   DialogContent,
//   Popper,
//   Grow,
//   Paper,
//   ClickAwayListener,
//   List,
//   ListItem,
//   ListItemText,
// } from '@mui/material';
// import CloudUpload from '@mui/icons-material/CloudUpload';
// import LinkIcon from '@mui/icons-material/Link';
// import CloseIcon from '@mui/icons-material/Close';

// const PropertyCommercial = ({
//   commercialPropertyTypes,
//   setCommercialPropertyTypes,
//   selectedPropertyType,
//   setSelectedPropertyType,
//   propertyImages,
//   setPropertyImages,
//   imagePreviews,
//   setImagePreviews,
//   buildingName,
//   setBuildingName,
//   areaName,
//   setAreaName,
//   completeAddress,
//   setCompleteAddress,
//   propertyDescription,
//   setPropertyDescription,
//   socialMediaLink,
//   setSocialMediaLink,
//   propertySize,
//   setPropertySize,
//   selectedUnit,
//   setSelectedUnit,
//   builtUpArea,
//   setBuiltUpArea,
//   builtUpAreaUnits,
//   setBuiltUpAreaUnits,
//   carpetArea,
//   setCarpetArea,
//   carpetAreaUnits,
//   setCarpetAreaUnits,
//   zoneType,
//   setZoneType,
//   totalFloors,
//   setTotalFloors,
//   selectedFloor,
//   setSelectedFloor,
//   selectedHub,
//   setSelectedHub,
//   selectedOwnership,
//   setSelectedOwnership,
//   floorsAvailable,
//   setFloorsAvailable,
//   hubs,
//   ownerships,
//   propertyLength,
//   setPropertyLength,
//   lengthUnit,
//   setLengthUnit,
//   propertyWidth,
//   setPropertyWidth,
//   widthUnit,
//   setWidthUnit,
//   selectedBHK,
//   setSelectedBHK,
//   selectedFurnish,
//   setSelectedFurnish,
//   bhkOptions,
//   furnishTypes,
//   ownerName,
//   setOwnerName,
//   contactNumber,
//   setContactNumber,
//   emailAddress,
//   setEmailAddress,
//   profileData,
//   errors,
//   setErrors,
//   areaSuggestions,
//   setAreaSuggestions,
//   showAreaSuggestions,
//   setShowAreaSuggestions,
//   areaAnchorEl,
//   setAreaAnchorEl,
//   selectedAreaDetails,
//   setSelectedAreaDetails,
//   selectedImageIndex,
//   setSelectedImageIndex,
//   previewOpen,
//   setPreviewOpen,
//   validateAlphanumeric,
//   validateNumber,
//   validateName,
//   validateEmail,
//   validatePhone,
//   validateAlphanumericField,
//   validateSocialMediaLink,
//   location,
// }) => {
//   const selectedType = commercialPropertyTypes.find(type => type.id === selectedPropertyType);
//   const isOffice = selectedType?.id === 'office';
//   const isShowroom = selectedType?.id === 'showroom';
//   const isRetailShop = selectedType?.id === 'retail-shop';
//   const isWarehouse = selectedType?.id === 'warehouse';
//   const isPlot = selectedType?.id === 'plot';
//   const isFarmhouse = selectedType?.id === 'farm-house';

//   // Get category from location state
//   const category = location.state?.category || 'Sell';
//   const isRental = category === 'Rent';

//   const handlePropertyTypeSelect = (typeId) => {
//     setSelectedPropertyType(typeId);
//     const updatedTypes = commercialPropertyTypes.map(type => ({
//       ...type,
//       selected: type.id === typeId
//     }));
//     setCommercialPropertyTypes(updatedTypes);
//   };

//   const handleImageUpload = (event) => {
//     const files = event.target.files;
//     if (!files || files.length === 0) return;
//     if (files.length > 10) {
//       alert("You can only upload up to 10 images");
//       return;
//     }

//     const validFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
//     if (validFiles.length !== files.length) {
//       alert("Only image files are allowed (JPEG, PNG, GIF, etc.)");
//       return;
//     }

//     const newPreviews = [];
//     const fileProcessPromises = validFiles.map(file => {
//       return new Promise((resolve) => {
//         const reader = new FileReader();
//         reader.onload = (e) => {
//           newPreviews.push(e.target.result);
//           resolve();
//         };
//         reader.onerror = () => {
//           console.error(`Failed to read file: ${file.name}`);
//           resolve();
//         };
//         reader.readAsDataURL(file);
//       });
//     });

//     Promise.all(fileProcessPromises).then(() => {
//       const updatedPreviews = [...imagePreviews, ...newPreviews];
//       const updatedFiles = [...propertyImages, ...validFiles];
//       setImagePreviews(updatedPreviews);
//       setPropertyImages(updatedFiles);
//       localStorage.setItem('propertyImagePreviews', JSON.stringify(updatedPreviews));
//       // Clear image error when images are uploaded
//       if (errors.propertyImages) {
//         setErrors(prev => ({...prev, propertyImages: ''}));
//       }
//     });
//   };

//   const handleAreaNameChange = (e) => {
//     const value = e.target.value;
//     setAreaName(value);
//     setAreaAnchorEl(e.currentTarget);
//     if (!value) {
//       setErrors(prev => ({...prev, areaName: 'Area Name is required'}));
//     } else if (value.trim().length < 1) {
//       setErrors(prev => ({...prev, areaName: 'Area Name must be at least 3 characters'}));
//     } else {
//       setErrors(prev => ({...prev, areaName: ''}));
//     }
//   };

//   const handleSelectArea = (area) => {
//     setAreaName(area.area);
//     setSelectedAreaDetails({
//       name: area.area,
//       address: area.address,
//       location: area.location
//     });
//     setAreaAnchorEl(null);
//     setShowAreaSuggestions(false);
//     setErrors(prev => ({...prev, areaName: ''}));
//   };

//   const handleAreaClickAway = () => {
//     setShowAreaSuggestions(false);
//   };

//   const fetchAreaSuggestions = async (query, city) => {
//     if (query.length < 1 || !city) return;
//     try {
//       const response = await fetch(`https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`);
//       const data = await response.json();
//       if (data.success && data.areas && data.areas.length > 0) {
//         const transformedAreas = data.areas.map(area => ({
//           area: area.name,
//           address: area.address,
//           location: area.location
//         }));
//         setAreaSuggestions(transformedAreas);
//         setShowAreaSuggestions(true);
//       } else {
//         setAreaSuggestions([]);
//         setShowAreaSuggestions(false);
//       }
//     } catch (error) {
//       console.error('Error fetching area suggestions:', error);
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//     }
//   };

//   React.useEffect(() => {
//     if (areaName.trim().length > 0 && location.state?.location) {
//       fetchAreaSuggestions(areaName, location.state.location);
//     } else {
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//     }
//   }, [areaName, location.state?.location]);

//   return (
//     <Box>
//       {/* Property Type & Upload Images */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '410px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Property Type <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <FormControl fullWidth size="small">
//               <Select
//                 value={selectedPropertyType}
//                 onChange={(e) => handlePropertyTypeSelect(e.target.value)}
//                 displayEmpty
//                 sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                 renderValue={(selected) => {
//                   const selectedTypeObj = commercialPropertyTypes.find(type => type.id === selected);
//                   if (!selectedTypeObj) {
//                     return <em style={{ color: '#999' }}>Select Property Type</em>;
//                   }
//                   return (
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <Box component="img" src={selectedTypeObj.icon} alt={selectedTypeObj.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
//                       <Typography sx={{ fontFamily: 'Outfit', fontSize: '13px' }}>
//                         {selectedTypeObj.name}
//                       </Typography>
//                     </Box>
//                   );
//                 }}
//               >
//                 {commercialPropertyTypes.map((type) => (
//                   <MenuItem key={type.id} value={type.id}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <Box component="img" src={type.icon} alt={type.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
//                       {type.name}
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>
//         </Grid>

//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '410px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Upload Images <span style={{ color: '#d32f2f' }}>*</span> {/* ✅ MANDATORY */}
//             </Typography>
//             <Box
//               sx={{
//                 height: 36,
//                 border: `2px dashed ${errors.propertyImages ? '#d32f2f' : '#d0d0d0'}`,
//                 borderRadius: 1.5,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 cursor: 'pointer',
//                 transition: 'all 0.2s ease',
//                 '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#1976d2' },
//               }}
//               onClick={() => document.getElementById('property-images').click()}
//             >
//               <input
//                 type="file"
//                 id="property-images"
//                 multiple
//                 accept="image/*"
//                 style={{ display: 'none' }}
//                 onChange={handleImageUpload}
//               />
//               <CloudUpload sx={{ width: 24, height: 24, mr: 1, color: '#1976d2' }} />
//               <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#666', fontFamily: 'Outfit' }}>
//                 Upload (Max 10)
//               </Typography>
//             </Box>
//             {errors.propertyImages && (
//               <Typography sx={{ fontSize: '11px', color: '#d32f2f', mt: 0.5, fontFamily: 'Outfit' }}>
//                 {errors.propertyImages}
//               </Typography>
//             )}
//           </Box>
//         </Grid>
//       </Grid>

//       {/* Display uploaded images */}
//       {imagePreviews && imagePreviews.length > 0 && (
//         <Box sx={{ mb: 3 }}>
//           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 1 }}>
//             {imagePreviews.length} {imagePreviews.length === 1 ? 'image' : 'images'} uploaded
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, p: 2, border: '1px solid #e0e0e0', borderRadius: 1.5, backgroundColor: '#fafafa' }}>
//             {imagePreviews.map((preview, index) => (
//               <Box
//                 key={`img-preview-${index}`}
//                 sx={{
//                   position: 'relative',
//                   width: '100px',
//                   height: '100px',
//                   borderRadius: 1.5,
//                   overflow: 'hidden',
//                   border: '2px solid #e0e0e0',
//                   cursor: 'pointer',
//                   flexShrink: 0,
//                   '&:hover': { borderColor: '#1976d2' }
//                 }}
//                 onClick={() => {
//                   setSelectedImageIndex(index);
//                   setPreviewOpen(true);
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={preview}
//                   alt={`Preview ${index + 1}`}
//                   sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                 />
//                 <IconButton
//                   size="small"
//                   sx={{
//                     position: 'absolute',
//                     top: -8,
//                     right: -8,
//                     bgcolor: '#ff4444',
//                     color: 'white',
//                     width: 24,
//                     height: 24,
//                     fontSize: '14px',
//                     '&:hover': { bgcolor: '#cc0000' }
//                   }}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     const newPreviews = [...imagePreviews];
//                     const newFiles = [...propertyImages];
//                     newPreviews.splice(index, 1);
//                     newFiles.splice(index, 1);
//                     setImagePreviews(newPreviews);
//                     setPropertyImages(newFiles);
//                     if (newPreviews.length > 0) {
//                       localStorage.setItem('propertyImagePreviews', JSON.stringify(newPreviews));
//                     } else {
//                       localStorage.removeItem('propertyImagePreviews');
//                     }
//                   }}
//                 >
//                   ×
//                 </IconButton>
//               </Box>
//             ))}
//           </Box>
//         </Box>
//       )}

//       {/* Building Name & Area Name */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '410px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Building/Project Name <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <TextField
//               id="buildingName"
//               fullWidth
//               size="small"
//               placeholder="Enter building name"
//               value={buildingName}
//               onChange={(e) => {
//                 setBuildingName(e.target.value);
//                 setErrors(prev => ({...prev, buildingName: validateAlphanumeric(e.target.value, "Building name")}));
//               }}
//               error={!!errors.buildingName}
//               helperText={errors.buildingName}
//               sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//             />
//           </Box>
//         </Grid>

//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '410px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Area Name <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <ClickAwayListener onClickAway={handleAreaClickAway}>
//               <Box sx={{ position: 'relative' }}>
//                 <TextField
//                   id="areaName"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter area name"
//                   value={areaName}
//                   onChange={handleAreaNameChange}
//                   error={!!errors.areaName}
//                   helperText={errors.areaName}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//                 {showAreaSuggestions && areaSuggestions.length > 0 && (
//                   <Popper
//                     open={showAreaSuggestions}
//                     anchorEl={areaAnchorEl}
//                     placement="bottom-start"
//                     transition
//                     style={{ width: areaAnchorEl ? areaAnchorEl.clientWidth : 'auto', zIndex: 1300 }}
//                   >
//                     {({ TransitionProps }) => (
//                       <Grow {...TransitionProps} timeout={200}>
//                         <Paper elevation={3} sx={{ maxHeight: 200, overflow: 'auto', mt: 0.5, border: '1px solid #e0e0e0', borderRadius: 1 }}>
//                           <List dense>
//                             {areaSuggestions.map((area, index) => (
//                               <ListItem
//                                 key={index}
//                                 button
//                                 onClick={() => handleSelectArea(area)}
//                                 sx={{ py: 0.8, '&:hover': { backgroundColor: '#f5f5f5' } }}
//                               >
//                                 <ListItemText
//                                   primary={area.area}
//                                   primaryTypographyProps={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '13px' }}
//                                 />
//                               </ListItem>
//                             ))}
//                           </List>
//                         </Paper>
//                       </Grow>
//                     )}
//                   </Popper>
//                 )}
//               </Box>
//             </ClickAwayListener>
//           </Box>
//         </Grid>
//       </Grid>

//       {/* Complete Address & Description */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '400px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Complete Address <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <TextField
//               id="completeAddress"
//               fullWidth
//               size="small"
//               multiline
//               rows={3}
//               placeholder="Enter address (max 5 digits allowed)"
//               value={completeAddress}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 const numbers = value.replace(/\D/g, '');
//                 if (numbers.length <= 5) {
//                   setCompleteAddress(value);
//                   setErrors(prev => ({...prev, completeAddress: validateAlphanumericField(value, "Complete address", true)}));
//                 }
//               }}
//               error={!!errors.completeAddress}
//               helperText={errors.completeAddress}
//               sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//             />
//           </Box>
//         </Grid>

//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '400px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Description <span style={{ color: '#999', fontSize: '11px' }}>(Optional - max 5 digits)</span>
//             </Typography>
//             <TextField
//               id="propertyDescription"
//               fullWidth
//               size="small"
//               multiline
//               rows={3}
//               placeholder="Enter description (max 5 digits allowed)"
//               value={propertyDescription}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 const numbers = value.replace(/\D/g, '');
//                 if (numbers.length <= 5) {
//                   setPropertyDescription(value);
//                   if (value) {
//                     setErrors(prev => ({...prev, propertyDescription: validateAlphanumericField(value, "Description", false)}));
//                   } else {
//                     setErrors(prev => ({...prev, propertyDescription: ''}));
//                   }
//                 }
//               }}
//               error={!!errors.propertyDescription}
//               helperText={errors.propertyDescription}
//               sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//             />
//           </Box>
//         </Grid>
//       </Grid>

//       {/* ✅ COMMERCIAL OFFICE FIELDS */}
//       {isOffice && (
//         <>
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '410px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Property Size with Units Dropdown */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '280px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: 1 }}>
//                   <TextField
//                     id="propertySize"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter size"
//                     value={propertySize}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setPropertySize(value);
//                       setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                     }}
//                     error={!!errors.propertySize}
//                     helperText={errors.propertySize}
//                     sx={{ 
//                       flex: 1,
//                       '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
//                     }}
//                   />
//                   <FormControl size="small" sx={{ minWidth: 100 }}>
//                     <Select
//                       value={selectedUnit}
//                       onChange={(e) => setSelectedUnit(e.target.value)}
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="sq.feet">Sq.Ft</MenuItem>
//                       <MenuItem value="sq.yards">Sq.Yards</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Built-up Area and Zone Type (Optional) */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="builtUpArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter built-up area"
//                   value={builtUpArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setBuiltUpArea(value);
//                   }}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="zoneType"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter zone type"
//                   value={zoneType}
//                   onChange={(e) => setZoneType(e.target.value)}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Available Floors Section */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Available Floors <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Total Floors
//                   </Typography>
//                   <TextField
//                     id="totalFloors"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter total floors"
//                     value={totalFloors}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setTotalFloors(value);
//                       setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
//                     }}
//                     error={!!errors.totalFloors}
//                     helperText={errors.totalFloors}
//                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Select Floor
//                   </Typography>
//                   <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
//                     <Select
//                       id="selectedFloor"
//                       value={selectedFloor}
//                       onChange={(e) => {
//                         setSelectedFloor(e.target.value);
//                         setErrors({...errors, selectedFloor: ''});
//                       }}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="" disabled>Select Floor</MenuItem>
//                       {[...Array(20)].map((_, i) => (
//                         <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
//                           {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
//                         </MenuItem>
//                       ))}
//                     </Select>
//                     {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
//                   </FormControl>
//                 </Box>
//               </Grid>_
//                            <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     IT / Business Hub
//                   </Typography>
//                   <FormControl fullWidth size="small" error={!!errors.selectedHub}>
//                     <Select
//                       id="selectedHub"
//                       value={selectedHub}
//                       onChange={(e) => {
//                         setSelectedHub(e.target.value);
//                         setErrors({...errors, selectedHub: ''});
//                       }}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="" disabled>Select Hub</MenuItem>
//                       {hubs.map((hub) => (
//                         <MenuItem key={hub} value={hub}>{hub}</MenuItem>
//                       ))}
//                     </Select>
//                     {errors.selectedHub && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedHub}</FormHelperText>}
//                   </FormControl>
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Ownership
//                   </Typography>
//                   <FormControl fullWidth size="small">
//                     <Select
//                       id="selectedOwnership"
//                       value={selectedOwnership}
//                       onChange={(e) => setSelectedOwnership(e.target.value)}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value=""><em>Select Ownership</em></MenuItem>
//                       {ownerships.map((own) => (
//                         <MenuItem key={own} value={own}>{own}</MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>

//           {/* Contact Information */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Email Address
//                   </Typography>
//                   <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>
//         </>
//       )}

//       {/* ✅ COMMERCIAL SHOWROOM FIELDS */}
//       {isShowroom && (
//         <>
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '410px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Property Size with Units Dropdown */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '280px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: 1 }}>
//                   <TextField
//                     id="propertySize"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter size"
//                     value={propertySize}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setPropertySize(value);
//                       setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                     }}
//                     error={!!errors.propertySize}
//                     helperText={errors.propertySize}
//                     sx={{ 
//                       flex: 1,
//                       '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
//                     }}
//                   />
//                   <FormControl size="small" sx={{ minWidth: 100 }}>
//                     <Select
//                       value={selectedUnit}
//                       onChange={(e) => setSelectedUnit(e.target.value)}
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="sq.feet">Sq.Ft</MenuItem>
//                       <MenuItem value="sq.yards">Sq.Yards</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Built-up Area and Zone Type (Optional) */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="builtUpArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter built-up area"
//                   value={builtUpArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setBuiltUpArea(value);
//                   }}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="zoneType"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter zone type"
//                   value={zoneType}
//                   onChange={(e) => setZoneType(e.target.value)}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Available Floors Section */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Available Floors <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Total Floors
//                   </Typography>
//                   <TextField
//                     id="totalFloors"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter total floors"
//                     value={totalFloors}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setTotalFloors(value);
//                       setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
//                     }}
//                     error={!!errors.totalFloors}
//                     helperText={errors.totalFloors}
//                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Select Floor
//                   </Typography>
//                   <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
//                     <Select
//                       id="selectedFloor"
//                       value={selectedFloor}
//                       onChange={(e) => {
//                         setSelectedFloor(e.target.value);
//                         setErrors({...errors, selectedFloor: ''});
//                       }}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="" disabled>Select Floor</MenuItem>
//                       {[...Array(20)].map((_, i) => (
//                         <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
//                           {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
//                         </MenuItem>
//                       ))}
//                     </Select>
//                     {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
//                   </FormControl>
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     IT / Business Hub
//                   </Typography>
//                   <FormControl fullWidth size="small" error={!!errors.selectedHub}>
//                     <Select
//                       id="selectedHub"
//                       value={selectedHub}
//                       onChange={(e) => {
//                         setSelectedHub(e.target.value);
//                         setErrors({...errors, selectedHub: ''});
//                       }}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="" disabled>Select Hub</MenuItem>
//                       {hubs.map((hub) => (
//                         <MenuItem key={hub} value={hub}>{hub}</MenuItem>
//                       ))}
//                     </Select>
//                     {errors.selectedHub && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedHub}</FormHelperText>}
//                   </FormControl>
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Ownership
//                   </Typography>
//                   <FormControl fullWidth size="small">
//                     <Select
//                       id="selectedOwnership"
//                       value={selectedOwnership}
//                       onChange={(e) => setSelectedOwnership(e.target.value)}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value=""><em>Select Ownership</em></MenuItem>
//                       {ownerships.map((own) => (
//                         <MenuItem key={own} value={own}>{own}</MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>

//           {/* Contact Information */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Email Address
//                   </Typography>
//                   <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>
//         </>
//       )}

//       {/* ✅ COMMERCIAL RETAIL SHOP FIELDS */}
//       {isRetailShop && (
//         <>
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '410px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Property Size with Units Dropdown */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '280px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: 1 }}>
//                   <TextField
//                     id="propertySize"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter size"
//                     value={propertySize}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setPropertySize(value);
//                       setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                     }}
//                     error={!!errors.propertySize}
//                     helperText={errors.propertySize}
//                     sx={{ 
//                       flex: 1,
//                       '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
//                     }}
//                   />
//                   <FormControl size="small" sx={{ minWidth: 100 }}>
//                     <Select
//                       value={selectedUnit}
//                       onChange={(e) => setSelectedUnit(e.target.value)}
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="sq.feet">Sq.Ft</MenuItem>
//                       <MenuItem value="sq.yards">Sq.Yards</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Built-up Area and Zone Type (Optional) */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="builtUpArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter built-up area"
//                   value={builtUpArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setBuiltUpArea(value);
//                   }}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="zoneType"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter zone type"
//                   value={zoneType}
//                   onChange={(e) => setZoneType(e.target.value)}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Available Floors Section */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Available Floors <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">_
//                                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Total Floors
//                   </Typography>
//                   <TextField
//                     id="totalFloors"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter total floors"
//                     value={totalFloors}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setTotalFloors(value);
//                       setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
//                     }}
//                     error={!!errors.totalFloors}
//                     helperText={errors.totalFloors}
//                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Select Floor
//                   </Typography>
//                   <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
//                     <Select
//                       id="selectedFloor"
//                       value={selectedFloor}
//                       onChange={(e) => {
//                         setSelectedFloor(e.target.value);
//                         setErrors({...errors, selectedFloor: ''});
//                       }}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="" disabled>Select Floor</MenuItem>
//                       {[...Array(20)].map((_, i) => (
//                         <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
//                           {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
//                         </MenuItem>
//                       ))}
//                     </Select>
//                     {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
//                   </FormControl>
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     IT / Business Hub
//                   </Typography>
//                   <FormControl fullWidth size="small" error={!!errors.selectedHub}>
//                     <Select
//                       id="selectedHub"
//                       value={selectedHub}
//                       onChange={(e) => {
//                         setSelectedHub(e.target.value);
//                         setErrors({...errors, selectedHub: ''});
//                       }}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="" disabled>Select Hub</MenuItem>
//                       {hubs.map((hub) => (
//                         <MenuItem key={hub} value={hub}>{hub}</MenuItem>
//                       ))}
//                     </Select>
//                     {errors.selectedHub && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedHub}</FormHelperText>}
//                   </FormControl>
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Ownership
//                   </Typography>
//                   <FormControl fullWidth size="small">
//                     <Select
//                       id="selectedOwnership"
//                       value={selectedOwnership}
//                       onChange={(e) => setSelectedOwnership(e.target.value)}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value=""><em>Select Ownership</em></MenuItem>
//                       {ownerships.map((own) => (
//                         <MenuItem key={own} value={own}>{own}</MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>

//           {/* Contact Information */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Email Address
//                   </Typography>
//                   <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>
//         </>
//       )}

//       {/* ✅ COMMERCIAL WAREHOUSE FIELDS */}
//       {isWarehouse && (
//         <>
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '410px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Property Size with Units Dropdown */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '280px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: 1 }}>
//                   <TextField
//                     id="propertySize"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter size"
//                     value={propertySize}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setPropertySize(value);
//                       setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                     }}
//                     error={!!errors.propertySize}
//                     helperText={errors.propertySize}
//                     sx={{ 
//                       flex: 1,
//                       '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
//                     }}
//                   />
//                   <FormControl size="small" sx={{ minWidth: 100 }}>
//                     <Select
//                       value={selectedUnit}
//                       onChange={(e) => setSelectedUnit(e.target.value)}
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="sq.feet">Sq.Ft</MenuItem>
//                       <MenuItem value="sq.yards">Sq.Yards</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Built-up Area and Zone Type (Optional) */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="builtUpArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter built-up area"
//                   value={builtUpArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setBuiltUpArea(value);
//                   }}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="zoneType"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter zone type"
//                   value={zoneType}
//                   onChange={(e) => setZoneType(e.target.value)}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Ownership */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <FormControl fullWidth size="small">
//                   <Select
//                     id="selectedOwnership"
//                     value={selectedOwnership}
//                     onChange={(e) => setSelectedOwnership(e.target.value)}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value=""><em>Select Ownership</em></MenuItem>
//                     {ownerships.map((own) => (
//                       <MenuItem key={own} value={own}>{own}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Contact Information */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Email Address
//                   </Typography>
//                   <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>
//         </>
//       )}

//       {/* ✅ COMMERCIAL PLOT FIELDS */}
//       {isPlot && (
//         <>
//           {/* Social Media Link */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '410px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Property Size with Units Dropdown, Zone Type, Ownership */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: 1 }}>
//                   <TextField
//                     id="propertySize"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter size"
//                     value={propertySize}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setPropertySize(value);
//                       setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                     }}
//                     error={!!errors.propertySize}
//                     helperText={errors.propertySize}
//                     sx={{ 
//                       flex: 1,
//                       '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
//                     }}
//                   />
//                   <FormControl size="small" sx={{ minWidth: 100 }}>
//                     <Select
//                       value={selectedUnit}
//                       onChange={(e) => setSelectedUnit(e.target.value)}
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="sq.feet">Sq.Ft</MenuItem>
//                       <MenuItem value="sq.yards">Sq.Yards</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="zoneType"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter zone type"
//                   value={zoneType}
//                   onChange={(e) => setZoneType(e.target.value)}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <FormControl fullWidth size="small">
//                   <Select
//                     id="selectedOwnership"
//                     value={selectedOwnership}
//                     onChange={(e) => setSelectedOwnership(e.target.value)}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value=""><em>Select Ownership</em></MenuItem>
//                     {ownerships.map((own) => (
//                       <MenuItem key={own} value={own}>{own}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Length and Width - Units changed to Feet */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Length <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="propertyLength"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter length"
//                   value={propertyLength}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setPropertyLength(value);
//                   }}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Feet</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Width <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="propertyWidth"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter width"
//                   value={propertyWidth}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setPropertyWidth(value);
//                   }}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Feet</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Contact Information */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: '_Outfit', mb: 2 }}>
//               Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Email Address
//                   </Typography>
//                   <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>
//         </>
//       )}

//       {/* ✅ COMMERCIAL FARMHOUSE FIELDS */}
//       {isFarmhouse && (
//         <>
//           {/* Social Media Link, BHK, Furnish Type */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '300px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '180px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   BHK <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.bhk}>
//                   <Select
//                     value={selectedBHK}
//                     onChange={(e) => {
//                       setSelectedBHK(e.target.value);
//                       setErrors({...errors, bhk: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                     {bhkOptions.map((option) => (
//                       <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '230px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.furnish}>
//                   <Select
//                     value={selectedFurnish}
//                     onChange={(e) => {
//                       setSelectedFurnish(e.target.value);
//                       setErrors({...errors, furnish: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                     {furnishTypes.map((type) => (
//                       <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Built-up Area (MANDATORY), Carpet Area (OPTIONAL), and Property Size with Units Dropdown */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="builtUpArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter built-up area"
//                   value={builtUpArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setBuiltUpArea(value);
//                     setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
//                   }}
//                   error={!!errors.builtUpArea}
//                   helperText={errors.builtUpArea}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="carpetArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter carpet area"
//                   value={carpetArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setCarpetArea(value);
//                   }}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: 1 }}>
//                   <TextField
//                     id="propertySize"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter size"
//                     value={propertySize}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setPropertySize(value);
//                       setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                     }}
//                     error={!!errors.propertySize}
//                     helperText={errors.propertySize}
//                     sx={{ 
//                       flex: 1,
//                       '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
//                     }}
//                   />
//                   <FormControl size="small" sx={{ minWidth: 100 }}>
//                     <Select
//                       value={selectedUnit}
//                       onChange={(e) => setSelectedUnit(e.target.value)}
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="sq.feet">Sq.Ft</MenuItem>
//                       <MenuItem value="sq.yards">Sq.Yards</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Contact Information */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Email Address
//                   </Typography>
//                   <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>
//         </>
//       )}

//       {/* Image Preview Dialog */}
//       {imagePreviews.length > 0 && (
//         <Dialog
//           open={previewOpen}
//           onClose={() => setPreviewOpen(false)}
//           maxWidth="md"
//           fullWidth
//           sx={{ '& .MuiDialog-paper': { borderRadius: '12px', overflow: 'hidden', bgcolor: 'black' } }}
//         >
//           <DialogContent sx={{ p: 0, position: 'relative' }}>
//             <Box
//               component="img"
//               src={imagePreviews[selectedImageIndex]}
//               alt={`Image ${selectedImageIndex + 1}`}
//               sx={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain' }}
//             />
//             <IconButton
//               onClick={() => setPreviewOpen(false)}
//               sx={{
//                 position: 'absolute',
//                 top: 8,
//                 right: 8,
//                 bgcolor: 'rgba(255, 255, 255, 0.3)',
//                 color: 'white',
//                 '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//             {imagePreviews.length > 1 && (
//               <>
//                 <IconButton
//                   onClick={() => setSelectedImageIndex(prev => (prev > 0 ? prev - 1 : imagePreviews.length - 1))}
//                   sx={{
//                     position: 'absolute',
//                     left: 8,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     bgcolor: 'rgba(255, 255, 255, 0.3)',
//                     color: 'white',
//                     '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
//                   }}
//                 >
//                   ‹
//                 </IconButton>
//                 <IconButton
//                   onClick={() => setSelectedImageIndex(prev => (prev < imagePreviews.length - 1 ? prev + 1 : 0))}
//                   sx={{
//                     position: 'absolute',
//                     right: 8,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     bgcolor: 'rgba(255, 255, 255, 0.3)',
//                     color: 'white',
//                     '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
//                   }}
//                 >
//                   ›
//                 </IconButton>
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     bottom: 16,
//                     left: '50%',
//                     transform: 'translateX(-50%)',
//                     bgcolor: 'rgba(0, 0, 0, 0.7)',
//                     color: 'white',
//                     px: 2,
//                     py: 1,
//                     borderRadius: '16px',
//                     fontSize: '14px',
//                     fontFamily: 'Outfit'
//                   }}
//                 >
//                   {selectedImageIndex + 1} / {imagePreviews.length}
//                 </Box>
//               </>
//             )}
//           </DialogContent>
//         </Dialog>
//       )}
//     </Box>
//   );
// };

// export default PropertyCommercial;


import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  InputAdornment,
  IconButton,
  Dialog,
  DialogContent,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import CloudUpload from '@mui/icons-material/CloudUpload';
import LinkIcon from '@mui/icons-material/Link';
import CloseIcon from '@mui/icons-material/Close';

const PropertyCommercial = ({
  commercialPropertyTypes,
  setCommercialPropertyTypes,
  selectedPropertyType,
  setSelectedPropertyType,
  propertyImages,
  setPropertyImages,
  imagePreviews,
  setImagePreviews,
  buildingName,
  setBuildingName,
  areaName,
  setAreaName,
  completeAddress,
  setCompleteAddress,
  propertyDescription,
  setPropertyDescription,
  socialMediaLink,
  setSocialMediaLink,
  propertySize,
  setPropertySize,
  selectedUnit,
  setSelectedUnit,
  builtUpArea,
  setBuiltUpArea,
  builtUpAreaUnits,
  setBuiltUpAreaUnits,
  carpetArea,
  setCarpetArea,
  carpetAreaUnits,
  setCarpetAreaUnits,
  zoneType,
  setZoneType,
  totalFloors,
  setTotalFloors,
  selectedFloor,
  setSelectedFloor,
  selectedHub,
  setSelectedHub,
  selectedOwnership,
  setSelectedOwnership,
  floorsAvailable,
  setFloorsAvailable,
  hubs,
  ownerships,
  propertyLength,
  setPropertyLength,
  lengthUnit,
  setLengthUnit,
  propertyWidth,
  setPropertyWidth,
  widthUnit,
  setWidthUnit,
  selectedBHK,
  setSelectedBHK,
  selectedFurnish,
  setSelectedFurnish,
  bhkOptions,
  furnishTypes,
  ownerName,
  setOwnerName,
  contactNumber,
  setContactNumber,
  emailAddress,
  setEmailAddress,
  profileData,
  errors,
  setErrors,
  areaSuggestions,
  setAreaSuggestions,
  showAreaSuggestions,
  setShowAreaSuggestions,
  areaAnchorEl,
  setAreaAnchorEl,
  selectedAreaDetails,
  setSelectedAreaDetails,
  selectedImageIndex,
  setSelectedImageIndex,
  previewOpen,
  setPreviewOpen,
  validateAlphanumeric,
  validateNumber,
  validateName,
  validateEmail,
  validatePhone,
  validateAlphanumericField,
  validateSocialMediaLink,
  location,
}) => {
  const selectedType = commercialPropertyTypes.find(type => type.id === selectedPropertyType);
  const isOffice = selectedType?.id === 'office';
  const isShowroom = selectedType?.id === 'showroom';
  const isRetailShop = selectedType?.id === 'retail-shop';
  const isWarehouse = selectedType?.id === 'warehouse';
  const isPlot = selectedType?.id === 'plot';
  const isFarmhouse = selectedType?.id === 'farm-house';

  const handlePropertyTypeSelect = (typeId) => {
    setSelectedPropertyType(typeId);
    const updatedTypes = commercialPropertyTypes.map(type => ({
      ...type,
      selected: type.id === typeId
    }));
    setCommercialPropertyTypes(updatedTypes);
  };

  const handleImageUpload = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;
    if (files.length > 10) {
      alert("You can only upload up to 10 images");
      return;
    }

    const validFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
    if (validFiles.length !== files.length) {
      alert("Only image files are allowed (JPEG, PNG, GIF, etc.)");
      return;
    }

    const newPreviews = [];
    const fileProcessPromises = validFiles.map(file => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          newPreviews.push(e.target.result);
          resolve();
        };
        reader.onerror = () => {
          console.error(`Failed to read file: ${file.name}`);
          resolve();
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(fileProcessPromises).then(() => {
      const updatedPreviews = [...imagePreviews, ...newPreviews];
      const updatedFiles = [...propertyImages, ...validFiles];
      setImagePreviews(updatedPreviews);
      setPropertyImages(updatedFiles);
      localStorage.setItem('propertyImagePreviews', JSON.stringify(updatedPreviews));
      if (errors.propertyImages) {
        setErrors(prev => ({...prev, propertyImages: ''}));
      }
    });
  };

  const handleAreaNameChange = (e) => {
    const value = e.target.value;
    setAreaName(value);
    setAreaAnchorEl(e.currentTarget);
    if (!value) {
      setErrors(prev => ({...prev, areaName: 'Area Name is required'}));
    } else if (value.trim().length < 1) {
      setErrors(prev => ({...prev, areaName: 'Area Name must be at least 3 characters'}));
    } else {
      setErrors(prev => ({...prev, areaName: ''}));
    }
  };

  const handleSelectArea = (area) => {
    setAreaName(area.area);
    setSelectedAreaDetails({
      name: area.area,
      address: area.address,
      location: area.location
    });
    setAreaAnchorEl(null);
    setShowAreaSuggestions(false);
    setErrors(prev => ({...prev, areaName: ''}));
  };

  const handleAreaClickAway = () => {
    setShowAreaSuggestions(false);
  };

  const fetchAreaSuggestions = async (query, city) => {
    if (query.length < 1 || !city) return;
    try {
      const response = await fetch(`https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`);
      const data = await response.json();
      if (data.success && data.areas && data.areas.length > 0) {
        const transformedAreas = data.areas.map(area => ({
          area: area.name,
          address: area.address,
          location: area.location
        }));
        setAreaSuggestions(transformedAreas);
        setShowAreaSuggestions(true);
      } else {
        setAreaSuggestions([]);
        setShowAreaSuggestions(false);
      }
    } catch (error) {
      console.error('Error fetching area suggestions:', error);
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
    }
  };

  React.useEffect(() => {
    if (areaName.trim().length > 0 && location.state?.location) {
      fetchAreaSuggestions(areaName, location.state.location);
    } else {
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
    }
  }, [areaName, location.state?.location]);

  return (
    <Box>
      {/* Property Type & Upload Images */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '410px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Property Type <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                value={selectedPropertyType}
                onChange={(e) => handlePropertyTypeSelect(e.target.value)}
                displayEmpty
                sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                renderValue={(selected) => {
                  const selectedTypeObj = commercialPropertyTypes.find(type => type.id === selected);
                  if (!selectedTypeObj) {
                    return <em style={{ color: '#999' }}>Select Property Type</em>;
                  }
                  return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box component="img" src={selectedTypeObj.icon} alt={selectedTypeObj.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
                      <Typography sx={{ fontFamily: 'Outfit', fontSize: '13px' }}>
                        {selectedTypeObj.name}
                      </Typography>
                    </Box>
                  );
                }}
              >
                {commercialPropertyTypes.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box component="img" src={type.icon} alt={type.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
                      {type.name}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '410px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Upload Images <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Box
              sx={{
                height: 36,
                border: `2px dashed ${errors.propertyImages ? '#d32f2f' : '#d0d0d0'}`,
                borderRadius: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#1976d2' },
              }}
              onClick={() => document.getElementById('property-images').click()}
            >
              <input
                type="file"
                id="property-images"
                multiple
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleImageUpload}
              />
              <CloudUpload sx={{ width: 24, height: 24, mr: 1, color: '#1976d2' }} />
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#666', fontFamily: 'Outfit' }}>
                Upload (Max 10)
              </Typography>
            </Box>
            {errors.propertyImages && (
              <Typography sx={{ fontSize: '11px', color: '#d32f2f', mt: 0.5, fontFamily: 'Outfit' }}>
                {errors.propertyImages}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Display uploaded images */}
      {imagePreviews && imagePreviews.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 1 }}>
            {imagePreviews.length} {imagePreviews.length === 1 ? 'image' : 'images'} uploaded
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, p: 2, border: '1px solid #e0e0e0', borderRadius: 1.5, backgroundColor: '#fafafa' }}>
            {imagePreviews.map((preview, index) => (
              <Box
                key={`img-preview-${index}`}
                sx={{
                  position: 'relative',
                  width: '100px',
                  height: '100px',
                  borderRadius: 1.5,
                  overflow: 'hidden',
                  border: '2px solid #e0e0e0',
                  cursor: 'pointer',
                  flexShrink: 0,
                  '&:hover': { borderColor: '#1976d2' }
                }}
                onClick={() => {
                  setSelectedImageIndex(index);
                  setPreviewOpen(true);
                }}
              >
                <Box
                  component="img"
                  src={preview}
                  alt={`Preview ${index + 1}`}
                  sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <IconButton
                  size="small"
                  sx={{
                    position: 'absolute',
                    top: -8,
                    right: -8,
                    bgcolor: '#ff4444',
                    color: 'white',
                    width: 24,
                    height: 24,
                    fontSize: '14px',
                    '&:hover': { bgcolor: '#cc0000' }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const newPreviews = [...imagePreviews];
                    const newFiles = [...propertyImages];
                    newPreviews.splice(index, 1);
                    newFiles.splice(index, 1);
                    setImagePreviews(newPreviews);
                    setPropertyImages(newFiles);
                    if (newPreviews.length > 0) {
                      localStorage.setItem('propertyImagePreviews', JSON.stringify(newPreviews));
                    } else {
                      localStorage.removeItem('propertyImagePreviews');
                    }
                  }}
                >
                  ×
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>
      )}

      {/* Building Name & Area Name */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '410px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Building/Project Name <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <TextField
              id="buildingName"
              fullWidth
              size="small"
              placeholder="Enter building name"
              value={buildingName}
              onChange={(e) => {
                setBuildingName(e.target.value);
                setErrors(prev => ({...prev, buildingName: validateAlphanumeric(e.target.value, "Building name")}));
              }}
              error={!!errors.buildingName}
              helperText={errors.buildingName}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '410px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Area Name <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <ClickAwayListener onClickAway={handleAreaClickAway}>
              <Box sx={{ position: 'relative' }}>
                <TextField
                  id="areaName"
                  fullWidth
                  size="small"
                  placeholder="Enter area name"
                  value={areaName}
                  onChange={handleAreaNameChange}
                  error={!!errors.areaName}
                  helperText={errors.areaName}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
                {showAreaSuggestions && areaSuggestions.length > 0 && (
                  <Popper
                    open={showAreaSuggestions}
                    anchorEl={areaAnchorEl}
                    placement="bottom-start"
                    transition
                    style={{ width: areaAnchorEl ? areaAnchorEl.clientWidth : 'auto', zIndex: 1300 }}
                  >
                    {({ TransitionProps }) => (
                      <Grow {...TransitionProps} timeout={200}>
                        <Paper elevation={3} sx={{ maxHeight: 200, overflow: 'auto', mt: 0.5, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                          <List dense>
                            {areaSuggestions.map((area, index) => (
                              <ListItem
                                key={index}
                                button
                                onClick={() => handleSelectArea(area)}
                                sx={{ py: 0.8, '&:hover': { backgroundColor: '#f5f5f5' } }}
                              >
                                <ListItemText
                                  primary={area.area}
                                  primaryTypographyProps={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '13px' }}
                                />
                              </ListItem>
                            ))}
                          </List>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                )}
              </Box>
            </ClickAwayListener>
          </Box>
        </Grid>
      </Grid>

           {/* Complete Address & Description */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '400px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Complete Address <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <TextField
              id="completeAddress"
              fullWidth
              size="small"
              multiline
              rows={3}
              placeholder="Enter address (max 5 digits allowed)"
              value={completeAddress}
              onChange={(e) => {
                const value = e.target.value;
                const numbers = value.replace(/\D/g, '');
                if (numbers.length <= 5) {
                  setCompleteAddress(value);
                  setErrors(prev => ({...prev, completeAddress: validateAlphanumericField(value, "Complete address", true)}));
                }
              }}
              error={!!errors.completeAddress}
              helperText={errors.completeAddress}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '400px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Description <span style={{ color: '#999', fontSize: '11px' }}>(Optional - max 5 digits)</span>
            </Typography>
            <TextField
              id="propertyDescription"
              fullWidth
              size="small"
              multiline
              rows={3}
              placeholder="Enter description (max 5 digits allowed)"
              value={propertyDescription}
              onChange={(e) => {
                const value = e.target.value;
                const numbers = value.replace(/\D/g, '');
                if (numbers.length <= 5) {
                  setPropertyDescription(value);
                  if (value) {
                    setErrors(prev => ({...prev, propertyDescription: validateAlphanumericField(value, "Description", false)}));
                  } else {
                    setErrors(prev => ({...prev, propertyDescription: ''}));
                  }
                }
              }}
              error={!!errors.propertyDescription}
              helperText={errors.propertyDescription}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
            />
          </Box>
        </Grid>
      </Grid>

      {/* ✅ COMMERCIAL OFFICE FIELDS */}
      {isOffice && (
        <>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '410px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Property Size */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '280px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Property Size <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="propertySize"
                  fullWidth
                  size="small"
                  placeholder="Enter property size"
                  value={propertySize}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setPropertySize(value);
                    setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                  }}
                  error={!!errors.propertySize}
                  helperText={errors.propertySize}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Built-up Area and Zone Type (Optional) */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="builtUpArea"
                  fullWidth
                  size="small"
                  placeholder="Enter built-up area"
                  value={builtUpArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setBuiltUpArea(value);
                  }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="zoneType"
                  fullWidth
                  size="small"
                  placeholder="Enter zone type"
                  value={zoneType}
                  onChange={(e) => setZoneType(e.target.value)}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Available Floors Section */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Available Floors <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '185px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Total Floors
                  </Typography>
                  <TextField
                    id="totalFloors"
                    fullWidth
                    size="small"
                    placeholder="Enter total floors"
                    value={totalFloors}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setTotalFloors(value);
                      setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
                    }}
                    error={!!errors.totalFloors}
                    helperText={errors.totalFloors}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '185px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Select Floor
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
                    <Select
                      id="selectedFloor"
                      value={selectedFloor}
                      onChange={(e) => {
                        setSelectedFloor(e.target.value);
                        setErrors({...errors, selectedFloor: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled>Select Floor</MenuItem>
                      {[...Array(20)].map((_, i) => (
                        <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
                          {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '200px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Ownership
                  </Typography>
                  <FormControl fullWidth size="small">
                    <Select
                      value={selectedOwnership}
                      onChange={(e) => setSelectedOwnership(e.target.value)}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
                      {ownerships.map((own) => (
                        <MenuItem key={own} value={own}>{own}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '200px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Hub
                  </Typography>
                  <FormControl fullWidth size="small">
                    <Select
                      value={selectedHub}
                      onChange={(e) => setSelectedHub(e.target.value)}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
                      {hubs.map((hub) => (
                        <MenuItem key={hub} value={hub}>{hub}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Contact Information - MANDATORY */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* ✅ COMMERCIAL SHOWROOM & RETAIL SHOP FIELDS */}
      {(isShowroom || isRetailShop) && (
        <>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '410px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Property Size */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '410px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Property Size <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="propertySize"
                  fullWidth
                  size="small"
                  placeholder="Enter property size"
                  value={propertySize}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setPropertySize(value);
                    setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                  }}
                  error={!!errors.propertySize}
                  helperText={errors.propertySize}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Built-up Area and Carpet Area (Optional) */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="builtUpArea"
                  fullWidth
                  size="small"
                  placeholder="Enter built-up area"
                  value={builtUpArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setBuiltUpArea(value);
                  }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="carpetArea"
                  fullWidth
                  size="small"
                  placeholder="Enter carpet area"
                  value={carpetArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setCarpetArea(value);
                  }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Available Floors Section */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Available Floors <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '185px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Total Floors
                  </Typography>
                  <TextField
                    id="totalFloors"
                    fullWidth
                    size="small"
                    placeholder="Enter total floors"
                    value={totalFloors}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setTotalFloors(value);
                      setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
                    }}
                    error={!!errors.totalFloors}
                    helperText={errors.totalFloors}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '185px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Select Floor
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
                    <Select
                      id="selectedFloor"
                      value={selectedFloor}
                      onChange={(e) => {
                        setSelectedFloor(e.target.value);
                        setErrors({...errors, selectedFloor: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled>Select Floor</MenuItem>
                      {[...Array(20)].map((_, i) => (
                        <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
                          {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '200px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Ownership
                  </Typography>
                  <FormControl fullWidth size="small">
                    <Select
                      value={selectedOwnership}
                      onChange={(e) => setSelectedOwnership(e.target.value)}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
                      {ownerships.map((own) => (
                        <MenuItem key={own} value={own}>{own}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '200px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Hub
                  </Typography>
                  <FormControl fullWidth size="small">
                    <Select
                      value={selectedHub}
                      onChange={(e) => setSelectedHub(e.target.value)}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
                      {hubs.map((hub) => (
                        <MenuItem key={hub} value={hub}>{hub}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Contact Information - MANDATORY */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* ✅ COMMERCIAL WAREHOUSE FIELDS */}
      {isWarehouse && (
        <>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '410px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Property Size */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '410px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Property Size <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="propertySize"
                  fullWidth
                  size="small"
                  placeholder="Enter property size"
                  value={propertySize}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setPropertySize(value);
                    setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                  }}
                  error={!!errors.propertySize}
                  helperText={errors.propertySize}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Zone Type, Built-up Area, Carpet Area (All Optional) */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="zoneType"
                  fullWidth
                  size="small"
                  placeholder="Enter zone type"
                  value={zoneType}
                  onChange={(e) => setZoneType(e.target.value)}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="builtUpArea"
                  fullWidth
                  size="small"
                  placeholder="Enter built-up area"
                  value={builtUpArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setBuiltUpArea(value);
                  }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="carpetArea"
                  fullWidth
                  size="small"
                  placeholder="Enter carpet area"
                  value={carpetArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setCarpetArea(value);
                  }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Available Floors Section */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Available Floors <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '185px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Total Floors
                  </Typography>
                  <TextField
                    id="totalFloors"
                    fullWidth
                    size="small"
                    placeholder="Enter total floors"
                    value={totalFloors}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setTotalFloors(value);
                      setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
                    }}
                    error={!!errors.totalFloors}
                    helperText={errors.totalFloors}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '185px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Select Floor
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
                    <Select
                      id="selectedFloor"
                      value={selectedFloor}
                      onChange={(e) => {
                        setSelectedFloor(e.target.value);
                        setErrors({...errors, selectedFloor: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled>Select Floor</MenuItem>
                      {[...Array(20)].map((_, i) => (
                        <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
                          {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '200px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Ownership
                  </Typography>
                  <FormControl fullWidth size="small">
                    <Select
                      value={selectedOwnership}
                      onChange={(e) => setSelectedOwnership(e.target.value)}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
                      {ownerships.map((own) => (
                        <MenuItem key={own} value={own}>{own}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '200px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Hub
                  </Typography>
                  <FormControl fullWidth size="small">
                    <Select
                      value={selectedHub}
                      onChange={(e) => setSelectedHub(e.target.value)}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
                      {hubs.map((hub) => (
                        <MenuItem key={hub} value={hub}>{hub}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Contact Information - MANDATORY */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* ✅ COMMERCIAL PLOT FIELDS */}
      {isPlot && (
        <>
          {/* Social Media Link */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '410px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Property Size, Zone Type, Ownership */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Property Size <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    sx={{ 
                      flex: 1,
                      '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
                    }}
                  />
                  <FormControl size="small" sx={{ minWidth: 100 }}>
                    <Select
                      value={selectedUnit}
                      onChange={(e) => setSelectedUnit(e.target.value)}
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="sq.yards">Sq.Yards</MenuItem>
                      <MenuItem value="acres">Acres</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="zoneType"
                  fullWidth
                  size="small"
                  placeholder="Enter zone type"
                  value={zoneType}
                  onChange={(e) => setZoneType(e.target.value)}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    value={selectedOwnership}
                    onChange={(e) => setSelectedOwnership(e.target.value)}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value=""><em>Select Ownership</em></MenuItem>
                    {ownerships.map((own) => (
                      <MenuItem key={own} value={own}>{own}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
          </Grid>

          {/* Length and Width */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Length <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="propertyLength"
                  fullWidth
                  size="small"
                  placeholder="Enter length"
                  value={propertyLength}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setPropertyLength(value);
                  }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Feet</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Width <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="propertyWidth"
                  fullWidth
                  size="small"
                  placeholder="Enter width"
                  value={propertyWidth}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setPropertyWidth(value);
                  }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Feet</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Contact Information - MANDATORY */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* ✅ COMMERCIAL FARMHOUSE FIELDS */}
      {isFarmhouse && (
        <>
          {/* Social Media Link, BHK, Furnish Type */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '300px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '180px', maxWidth: '100%'              }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  BHK <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.bhk}>
                  <Select
                    value={selectedBHK}
                    onChange={(e) => {
                      setSelectedBHK(e.target.value);
                      setErrors({...errors, bhk: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                    {bhkOptions.map((option) => (
                      <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '230px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.furnish}>
                  <Select
                    value={selectedFurnish}
                    onChange={(e) => {
                      setSelectedFurnish(e.target.value);
                      setErrors({...errors, furnish: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                    {furnishTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>
          </Grid>

          {/* Built-up Area (MANDATORY) and Property Size */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="builtUpArea"
                  fullWidth
                  size="small"
                  placeholder="Enter built-up area"
                  value={builtUpArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setBuiltUpArea(value);
                    setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
                  }}
                  error={!!errors.builtUpArea}
                  helperText={errors.builtUpArea}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Property Size <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="propertySize"
                  fullWidth
                  size="small"
                  placeholder="Enter property size"
                  value={propertySize}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setPropertySize(value);
                    setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                  }}
                  error={!!errors.propertySize}
                  helperText={errors.propertySize}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Contact Information - MANDATORY */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* Image Preview Dialog */}
      {imagePreviews.length > 0 && (
        <Dialog
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          maxWidth="md"
          fullWidth
          sx={{ '& .MuiDialog-paper': { borderRadius: '12px', overflow: 'hidden', bgcolor: 'black' } }}
        >
          <DialogContent sx={{ p: 0, position: 'relative' }}>
            <Box
              component="img"
              src={imagePreviews[selectedImageIndex]}
              alt={`Image ${selectedImageIndex + 1}`}
              sx={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain' }}
            />
            <IconButton
              onClick={() => setPreviewOpen(false)}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                bgcolor: 'rgba(255, 255, 255, 0.3)',
                color: 'white',
                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
              }}
            >
              <CloseIcon />
            </IconButton>
            {imagePreviews.length > 1 && (
              <>
                <IconButton
                  onClick={() => setSelectedImageIndex(prev => (prev > 0 ? prev - 1 : imagePreviews.length - 1))}
                  sx={{
                    position: 'absolute',
                    left: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(255, 255, 255, 0.3)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
                  }}
                >
                  ‹
                </IconButton>
                <IconButton
                  onClick={() => setSelectedImageIndex(prev => (prev < imagePreviews.length - 1 ? prev + 1 : 0))}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(255, 255, 255, 0.3)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
                  }}
                >
                  ›
                </IconButton>
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 16,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bgcolor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    px: 2,
                    py: 1,
                    borderRadius: '16px',
                    fontSize: '14px',
                    fontFamily: 'Outfit'
                  }}
                >
                  {selectedImageIndex + 1} / {imagePreviews.length}
                </Box>
              </>
            )}
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default PropertyCommercial;


